var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "stocktransfer",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "45px"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.handleSubmitForSearch($event)
      }
    }
  }, [_c('div', {
    staticClass: "search_barT"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 col-lg-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Unique Reference Number :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ShippingID),
      expression: "ShippingID"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "RefShippingID",
    staticClass: "form-control input_field_style",
    class: {
      'is-invalid': _vm.submitted && _vm.errors.has('ShippingID')
    },
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "text",
      "id": "ShippingID",
      "name": "ShippingID",
      "placeholder": "Enter Unique Reference Number"
    },
    domProps: {
      "value": (_vm.ShippingID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ShippingID = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-times reset_btn",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.resetShippingDetails
    }
  }), _vm._v(" "), (_vm.submitted && _vm.errors.has('ShippingID')) ? _c('div', {
    staticClass: "invalid-feedback"
  }, [_vm._v(" The Unique Reference\n                        Number field is required. ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-lg-4",
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handleSubmitForSearch($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Search Type :")]), _vm._v(" "), _c('basic-select', {
    staticStyle: {
      "width": "50%",
      "display": "inline-block",
      "cursor": "none"
    },
    attrs: {
      "options": _vm.SelectTypeOptionArr,
      "selected-option": _vm.SelectTypeOptionObj,
      "placeholder": "Select Search Type"
    },
    on: {
      "select": _vm.selectTypeOption
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-lg-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v("\n                          "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetTrackshipmentsummary
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")])])])])])])])])], 1)]), _vm._v(" "), (_vm.ShippingIDTypeMainDiv) ? _c('div', {
    staticStyle: {
      "margin-top": "-10px"
    },
    attrs: {
      "id": "ShippingIDTypeMainDiv"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h6', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("Shipment Details")]), _vm._v(" "), _c('div', {
    staticClass: "icon_mn"
  }, [(_vm.SalesDemo.NotificationStatus === 'SuperEscalation') ? _c('i', {
    staticClass: "fa fa-frown-o fa-icon-theme-color-red",
    staticStyle: {
      "padding-right": "0px"
    },
    attrs: {
      "title": "SuperEscalation",
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.SalesDemo.NotificationStatus === 'Escalation' || _vm.SalesDemo.EscalationMarkedbeforeDest) ? _c('i', {
    staticClass: "fa fa-meh-o fa-icon-theme-colorT fa-icon-theme-color-red",
    staticStyle: {
      "padding-right": "0px"
    },
    attrs: {
      "title": "Escalation",
      "aria-hidden": "true"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "card-body top_info_body"
  }, [_c('div', {
    staticClass: "user_info"
  }, [_c('table', {
    staticClass: "table table-responsive custom_table_style"
  }, [_c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("Parent AWB :")]), _vm._v(" "), _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(" " + _vm._s(_vm.SalesDemo.ParentAWB))])]), _vm._v(" "), _c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("MPS(BOX) COUNT:")]), _vm._v(" "), _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(" " + _vm._s(_vm.SalesDemo.MPSBoxCount))])]), _vm._v(" "), _c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("Client Name (ID) :")]), _vm._v(" "), (_vm.SalesDemo.ClientID == '409') ? _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v("\n                             " + _vm._s(_vm.SalesDemo.SenderName) + "\n                             (" + _vm._s(_vm.SalesDemo.ClientName) + ") (" + _vm._s(_vm.SalesDemo.ClientID) + ") ")]) : _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v("\n                             " + _vm._s(_vm.SalesDemo.ClientName) + " (" + _vm._s(_vm.SalesDemo.ClientID) + ")\n                          ")])]), _vm._v(" "), _c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("Bussiness :")]), _vm._v(" "), _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(" " + _vm._s(_vm.SalesDemo.Bussiness))])]), _vm._v(" "), _c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("Service Type :")]), _vm._v(" "), _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(" " + _vm._s(_vm.SalesDemo.ServiceType))])]), _vm._v(" "), _c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("Shipment Status :")]), _vm._v(" "), _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(" " + _vm._s(_vm.SalesDemo.ShipmentStatus))])]), _vm._v(" "), _c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("Status :")]), _vm._v(" "), _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(" " + _vm._s(_vm.SalesDemo.Status))])]), _vm._v(" "), _c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("Ship Type :")]), _vm._v(" "), _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(" " + _vm._s(_vm.SalesDemo.ShipType))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [(_vm.SalesDemo.BusinessFlow === 'Forward') ? _c('h6', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("Consignor Details")]) : _vm._e(), _vm._v(" "), (_vm.SalesDemo.BusinessFlow === 'Reverse') ? _c('h6', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("DTO Details")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "icon_mn"
  }, [_c('i', {
    staticClass: "fa fa-phone-square",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.OpenCallPatchingModel(_vm.PickupAddressContactDetails.PhoneNo, _vm.PickupAddressContactDetails.PhoneNoAlt,
          _vm.PickupAddress.Name, 'Consignor Details', 'B2B')
      }
    }
  }), _vm._v(" "), (_vm.PickupAddress.EmailID) ? _c('a', {
    attrs: {
      "href": ("mailto:" + (_vm.PickupAddress.EmailID))
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-open",
    staticStyle: {
      "padding-right": "0px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "card-body top_info_body"
  }, [_c('div', {
    staticClass: "user_info"
  }, [_c('table', {
    staticClass: "table table-responsive custom_table_style"
  }, [_c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("Name :")]), _vm._v(" "), _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(" " + _vm._s(_vm.PickupAddress.Name))])]), _vm._v(" "), _c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v(" Address :")]), _vm._v(" "), _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(" " + _vm._s(_vm.PickupAddress.Address))])]), _vm._v(" "), _c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("City :")]), _vm._v(" "), _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(" " + _vm._s(_vm.PickupAddress.City))])]), _vm._v(" "), _c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("State :")]), _vm._v(" "), _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(" " + _vm._s(_vm.PickupAddress.State))])]), _vm._v(" "), _c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("Pin Code :")]), _vm._v(" "), _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(" " + _vm._s(_vm.PickupAddress.PinCode))])]), _vm._v(" "), _c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("Contact No. :")]), _vm._v(" "), (_vm.PickupAddressContactDetails.PhoneNoDisplay && _vm.PickupAddressContactDetails.PhoneNoAltDisplay) ? _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v("\n                            " + _vm._s(_vm.PickupAddressContactDetails.PhoneNoDisplay) + " / " + _vm._s(_vm.PickupAddressContactDetails.PhoneNoAltDisplay) + "\n                          ")]) : _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v("\n                            " + _vm._s(_vm.PickupAddressContactDetails.PhoneNoDisplay) + " ")])]), _vm._v(" "), _c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("Email :")]), _vm._v(" "), _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(_vm._s(_vm.PickupAddress.EmailID))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h6', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("Consignee Details")]), _vm._v(" "), _c('div', {
    staticClass: "icon_mn"
  }, [(_vm.CustomerDetails.PhoneNo) ? _c('i', {
    staticClass: "fa fa-phone-square",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.OpenCallPatchingModel(_vm.CustomerDetails.PhoneNo, _vm.CustomerDetails.PhoneNoAlt,
          _vm.CustomerDetails.CustomerName, 'Customer Details', 'B2B')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.CustomerDetails.PhoneNo && _vm.SalesDemo.BusinessFlow === 'ForwardComment') ? _c('i', {
    staticClass: "fa fa-envelope",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.openSendSMSModal()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.CustomerDetails.EmailID) ? _c('a', {
    attrs: {
      "href": ("mailto:" + (_vm.CustomerDetails.EmailID))
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-open",
    staticStyle: {
      "padding-right": "0px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "card-body top_info_body"
  }, [_c('div', {
    staticClass: "user_info"
  }, [_c('table', {
    staticClass: "table table-responsive custom_table_style"
  }, [_c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("Name :")]), _vm._v(" "), _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(" " + _vm._s(_vm.CustomerDetails.CustomerName) + "\n                          ")])]), _vm._v(" "), _c('thead', [(_vm.SalesDemo.IsRedirectToBank && _vm.SalesDemo.RedirectToAddress === 'Secondary') ? _c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("Banking Address :")]) : (_vm.SalesDemo.IsRedirect && _vm.SalesDemo.RedirectToAddress === 'Secondary') ? _c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("Secondary Address :")]) : _c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("Primary Address :")]), _vm._v(" "), _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(" " + _vm._s(_vm.CustomerDetails.Address))])]), _vm._v(" "), _c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("City :")]), _vm._v(" "), _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(" " + _vm._s(_vm.CustomerDetails.City))])]), _vm._v(" "), _c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("State :")]), _vm._v(" "), _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(" " + _vm._s(_vm.CustomerDetails.State))])]), _vm._v(" "), _c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("Pin Code :")]), _vm._v(" "), _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(" " + _vm._s(_vm.CustomerDetails.PinCode))])]), _vm._v(" "), _c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("Contact No. :")]), _vm._v(" "), (_vm.CustomerDetails.PhoneNoDisplay && _vm.CustomerDetails.PhoneNoAltDisplay) ? _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v("\n                            " + _vm._s(_vm.CustomerDetails.PhoneNoDisplay) + " / " + _vm._s(_vm.CustomerDetails.PhoneNoAltDisplay) + "\n                          ")]) : _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v("\n                            " + _vm._s(_vm.CustomerDetails.PhoneNoDisplay) + " ")])]), _vm._v(" "), _c('thead', [_c('th', {
    staticClass: "tbl_th_lbl_width"
  }, [_vm._v("Email :")]), _vm._v(" "), _c('th', {
    staticClass: "text-left label_text_font tbl_th_txt_width"
  }, [_vm._v(_vm._s(_vm.CustomerDetails.EmailID))])])])])])])])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    model: {
      value: (_vm.SendSMS.SendSMSModal),
      callback: function($$v) {
        _vm.SendSMS.SendSMSModal = $$v
      },
      expression: "SendSMS.SendSMSModal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.SendSMS.SendSMSModal),
      expression: "SendSMS.SendSMSModal"
    }],
    staticClass: "col-lg-12",
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('b-card', {
    staticStyle: {
      "background-color": "transparent",
      "border": "0px solid transparent"
    }
  }, [_c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Send SMS")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeBModalCommonFunction('SendSMSModal')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.handleSubmitForSendSMS($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "Reason"
    }
  }, [_vm._v("Reason")]), _vm._v(" "), _c('basic-select', {
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "options": _vm.SendSMS.ReasonArr,
      "selected-option": _vm.SendSMS.SelectedReasonObj,
      "placeholder": "Select Reason"
    },
    on: {
      "select": _vm.selectedSMSReason
    },
    model: {
      value: (_vm.SendSMS.Reason),
      callback: function($$v) {
        _vm.SendSMS.Reason = $$v
      },
      expression: "SendSMS.Reason"
    }
  }), _vm._v(" "), (_vm.SendSMS.submitted && _vm.errors.has('SendSMS.Reason')) ? _c('div', {
    staticClass: "invalid-feedback"
  }, [_vm._v("\n                        " + _vm._s(_vm.errors.first('SendSMS.Reason')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "Message"
    }
  }, [_vm._v("Message")]), _vm._v(" "), _c('basic-select', {
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "options": _vm.SendSMS.SendSMSArr,
      "selected-option": _vm.SendSMS.SelectedSendSMSObj,
      "placeholder": "Select Message"
    },
    model: {
      value: (_vm.SendSMS.Message),
      callback: function($$v) {
        _vm.SendSMS.Message = $$v
      },
      expression: "SendSMS.Message"
    }
  }), _vm._v(" "), (_vm.SendSMS.submitted && _vm.errors.has('SendSMS.Message')) ? _c('div', {
    staticClass: "invalid-feedback"
  }, [_vm._v("\n                        " + _vm._s(_vm.errors.first('SendSMS.Message')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Send SMS")])])])], 1)])])])], 1)]), _vm._v(" "), _c('b-modal', {
    staticStyle: {
      "border-radius": "5px"
    },
    model: {
      value: (_vm.Callpatching.CallPatchingModal),
      callback: function($$v) {
        _vm.Callpatching.CallPatchingModal = $$v
      },
      expression: "Callpatching.CallPatchingModal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Callpatching.CallPatchingModal),
      expression: "Callpatching.CallPatchingModal"
    }],
    staticClass: "col-lg-12",
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('b-card', {
    staticStyle: {
      "background-color": "transparent",
      "border": "0px solid transparent",
      "margin-bottom": "0"
    }
  }, [_c('h5', {
    staticClass: "modal-title",
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Call Patching: " + _vm._s(_vm.Callpatching.addressType) + " ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeBModalCommonFunction('CallPatchingModal')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "card-body",
    staticStyle: {
      "padding-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Shiping Id:")]), _vm._v(" "), _c('div', [_c('label', [_vm._v(_vm._s(this.ShippingID))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Name:")]), _vm._v(" "), _c('div', [_c('label', [_vm._v(_vm._s(_vm.Callpatching.Name))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group "
  }, [_c('label', {
    staticStyle: {
      "font-weight": "bold",
      "cursor": "pointer"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Callpatching.optNumberType),
      expression: "Callpatching.optNumberType"
    }],
    attrs: {
      "type": "radio",
      "value": "1",
      "name": "optNumberType",
      "checked": ""
    },
    domProps: {
      "checked": _vm._q(_vm.Callpatching.optNumberType, "1")
    },
    on: {
      "__c": function($event) {
        _vm.Callpatching.optNumberType = "1"
      }
    }
  }), _vm._v(" Primary\n                      No.")]), _vm._v("\n                      \n                    "), _c('label', {
    staticStyle: {
      "font-weight": "bold",
      "cursor": "pointer"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Callpatching.optNumberType),
      expression: "Callpatching.optNumberType"
    }],
    attrs: {
      "type": "radio",
      "value": "2",
      "name": "optNumberType"
    },
    domProps: {
      "checked": _vm._q(_vm.Callpatching.optNumberType, "2")
    },
    on: {
      "__c": function($event) {
        _vm.Callpatching.optNumberType = "2"
      }
    }
  }), _vm._v(" Alternate\n                      No.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-4",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Call Type:")]), _vm._v(" "), _c('div', [(_vm.CallTypeOptionObj.length > 0) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CallType),
      expression: "CallType"
    }],
    staticClass: "select ",
    staticStyle: {
      "cursor": "pointer",
      "width": "150px",
      "height": "32px",
      "background-color": "rgb(255, 251, 251)",
      "border-color": "#7ca2e8",
      "text-align-last": "center"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.CallType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.CallTypeOptionObj), function(option) {
    return _c('option', {
      domProps: {
        "value": option
      }
    }, [_vm._v(_vm._s(option))])
  })) : _vm._e(), _vm._v(" "), (_vm.CallTypeOptionObj.length == 0) ? _c('label', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" Call type not available ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('a', {
    staticClass: "btn btn-success",
    staticStyle: {
      "color": "white",
      "margin-left": "15px"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.MakeCall()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-phone",
    staticStyle: {
      "color": "white"
    }
  }), _vm._v(" Call\n                    ")]), _vm._v("   \n                    "), _c('a', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.closeBModalCommonFunction('CallPatchingModal')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  }), _vm._v(" Close ")])])], 1)])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "-10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    class: {
      'glyphprogress': _vm.glyphprogress, 'short_glyphprogress': _vm.short_glyphprogress, 'short_short_glyphprogress': _vm.short_short_glyphprogress
    },
    attrs: {
      "id": "short_glyphprogress"
    }
  }, [_c('div', {
    class: {
      'connecting-line': _vm.connecting_line, 'short_connecting-line': _vm.short_connecting_line, 'short_short_connecting-line': _vm.short_short_connecting_line
    },
    attrs: {
      "id": "short_connecting-line"
    }
  }), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticClass: "glyphstep",
    class: [_vm.ShipmentTransactionLogSummary.IsLatestManifestDataReceived ? 'blink_cls' : '']
  }, [(_vm.SalesDemo.BusinessFlow === 'Forward') ? _c('i', {
    staticClass: "fa fa-home",
    staticStyle: {
      "color": "#FF4500"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.SalesDemo.BusinessFlow === 'Reverse') ? _c('i', {
    staticClass: "fa fa-home",
    staticStyle: {
      "color": "limegreen"
    }
  }) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "step_bar_txt"
  }, [_vm._v(_vm._s(_vm.ShipmentTransactionLogSummary.DataReceived))])]), _vm._v(" "), (_vm.ShipmentTransactionLogSummary.OriginHubDataLiShow) ? _c('li', [_c('span', {
    staticClass: "glyphstep",
    class: [_vm.ShipmentTransactionLogSummary.IsLatestOriginHubInScan ? 'blink_cls' : '']
  }, [_c('i', {
    staticClass: "fa fa-map-marker",
    staticStyle: {
      "color": "blue"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "step_bar_txt"
  }, [_vm._v(_vm._s(_vm.ShipmentTransactionLogSummary.OriginHubData) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.ShipmentTransactionLogSummary.currentHubDataLiShow) ? _c('li', {
    attrs: {
      "id": "currentHubDataDivShow"
    }
  }, [_c('span', {
    staticClass: "glyphstep",
    class: [_vm.ShipmentTransactionLogSummary.IsLatestCurrentHubInscanDate ? 'blink_cls' : '']
  }, [_c('i', {
    staticClass: "fa fa-map-marker",
    staticStyle: {
      "color": "blue"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "step_bar_txt"
  }, [_vm._v(_vm._s(_vm.ShipmentTransactionLogSummary.currentHubData))])]) : _vm._e(), _vm._v(" "), (_vm.ShipmentTransactionLogSummary.DestinationHubDataLiShow) ? _c('li', [_c('span', {
    staticClass: "glyphstep",
    class: [_vm.ShipmentTransactionLogSummary.IsLatestDestinationHubInscanDate ? 'blink_cls' : '']
  }, [_c('i', {
    staticClass: "fa fa-map-marker",
    staticStyle: {
      "color": "blue"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "step_bar_txt"
  }, [_vm._v(_vm._s(_vm.ShipmentTransactionLogSummary.DestinationHubData))])]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphstep",
    class: [_vm.ShipmentTransactionLogSummary.IsLatestOFD ? 'blink_cls' : '']
  }, [_c('img', {
    attrs: {
      "width": "50px",
      "height": "50px",
      "viewBox": "-7 -100 511 620",
      "src": "static/img/truck.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "step_bar_txt",
    staticStyle: {
      "padding": "1px !important",
      "margin-top": "10px"
    }
  }, [_vm._v("EDD : " + _vm._s(_vm.SalesDemo.EDD) + "\n                    ")]), _vm._v(" "), _c('p', {
    staticClass: "step_bar_txt",
    staticStyle: {
      "padding": "1px !important"
    }
  }, [_vm._v("PDD : " + _vm._s(_vm.SalesDemo.PDD))]), _vm._v(" "), (_vm.SalesDemo.IsLatestOFD) ? _c('p', {
    staticClass: "step_bar_txt",
    staticStyle: {
      "padding": "1px !important"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.SalesDemo.UserProcess) + " ")]) : _vm._e()]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphstep",
    class: [_vm.ShipmentTransactionLogSummary.IsLatestDeliveryDateTime ? 'blink_cls' : '']
  }, [(_vm.SalesDemo.BusinessFlow === 'Forward') ? _c('i', {
    staticClass: "fa fa-home",
    staticStyle: {
      "color": "limegreen"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.SalesDemo.BusinessFlow === 'Reverse') ? _c('i', {
    staticClass: "fa fa-home",
    staticStyle: {
      "color": "#FF4500"
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.SalesDemo.BusinessFlow === 'Forward') ? _c('span', [(_vm.SalesDemo.DeliveryDateTime && _vm.SalesDemo.Status === 'Delivered') ? _c('p', {
    staticClass: "step_bar_txt"
  }, [_vm._v("\n                        Delivery Status : Delivered\n                        "), _c('br'), _vm._v(" " + _vm._s(_vm.SalesDemo.DeliveryDateTime) + "\n                      ")]) : _c('p', {
    staticClass: "step_bar_txt"
  }, [_vm._v("Delivery Status : Pending")])]) : _c('span', [(_vm.SalesDemo.DeliveryDateTime && _vm.SalesDemo.ShipmentStatus === 'WHHandover') ? _c('p', {
    staticClass: "step_bar_txt"
  }, [_vm._v("DTO Status : WHHandover\n                        "), _c('br'), _vm._v(" " + _vm._s(_vm.SalesDemo.DeliveryDateTime) + "\n                      ")]) : _c('p', {
    staticClass: "step_bar_txt"
  }, [_vm._v("DTO Status : Pending")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "-10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-8 col-lg-8"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoadingCurrentStatusDiv,
      "is-full-page": false
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingCurrentStatusDiv = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "ext_btn"
  }, [_c('button', {
    staticClass: "btn btn-primary cst_btnT",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showPaperWorkModal()
      }
    }
  }, [_vm._v("Paper Work\n              ")]), _vm._v("   \n              "), (_vm.SearchType == 'ChildAWB') ? _c('button', {
    staticClass: "btn btn-primary cst_btn",
    attrs: {
      "id": "show-modal"
    },
    on: {
      "click": function($event) {
        _vm.showShipmentLogModal(_vm.SalesDemo.ShippingID)
      }
    }
  }, [_vm._v("Shipment\n                Logs")]) : _vm._e(), _vm._v("   \n\n              "), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary cst_btn",
    on: {
      "click": function($event) {
        _vm.ShowRaiseTicketDiv();
      }
    }
  }, [_vm._v("Raise Ticket")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary cst_btn",
    attrs: {
      "id": "show-ticket-modal"
    },
    on: {
      "click": function($event) {
        _vm.openTicketModal()
      }
    }
  }, [_vm._v("Show\n                Tickets")])]), _vm._v(" "), (_vm.SalesDemo.BusinessFlow == 'Forward') ? _c('b-tabs', [_c('b-tab', {
    attrs: {
      "title": "Current Status"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "title_txt"
  }, [(_vm.displayCurrentLocation && _vm.deliveryUserID) ? _c('span', [_c('h6', [_vm._v(" " + _vm._s(_vm.SalesDemo.UserProcess) + " By\n                        " + _vm._s(_vm.OrderDetails.srUserData.FirstName + ' ' + _vm.OrderDetails.srUserData.LastName) + "\n                      ")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-phone popup",
    on: {
      "click": _vm.myPopupFunction
    }
  }, [_c('span', {
    staticClass: "popuptext",
    attrs: {
      "id": "myPopup"
    }
  }, [_vm._v("+91-" + _vm._s(_vm.OrderDetails.srUserData.MobileNumber))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 br_right"
  }, [_c('table', {
    staticClass: "table table-responsive custom_table_style"
  }, [_c('thead', [_c('th', [_vm._v("Last NDR : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.ShipmentTransactionLogSummary.lastNDRUserProcess) + "\n                            " + _vm._s(_vm.ShipmentTransactionLogSummary.LastNDRDate) + "\n                          ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Notification Type :")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s(_vm.SalesDemo.NotificationType) + " ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Notification Status :")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s(_vm.SalesDemo.NotificationStatus) + " ")])]), _vm._v(" "), (_vm.showBASRDetails) ? _c('thead', [_c('th', [_vm._v("BA/SR Name :")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s(_vm.b2b_sr_vehicle_details.driver_name) + " ")])]) : _vm._e(), _vm._v(" "), (_vm.showBASRDetails) ? _c('thead', [_c('th', [_vm._v("BA/SR Vehicle Number :")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s(_vm.b2b_sr_vehicle_details.vehicle_number) + " ")])]) : _vm._e(), _vm._v(" "), (_vm.showBASRDetails) ? _c('thead', [_c('th', [_vm._v("BA/SR mobile number :")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s(_vm.b2b_sr_vehicle_details.driver_mobile_number) + " ")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  }, [_c('table', {
    staticClass: "table table-responsive custom_table_style"
  }, [_c('thead', [_c('th', [_vm._v("Mode of Transport :")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s(_vm.SalesDemo.ModeOfTransport) + " ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Total Attempts :")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s(_vm.SalesDemo.TotalAttemptCount) + " ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Appointment Date :")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s(_vm.SalesDemo.AppointmentDate) + " ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Reattempt Date :")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s(_vm.SalesDemo.ReattemptDate) + " ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Pickup Date :")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s(_vm.SalesDemo.PickupTimeSlotWithDate) + " ")])])])])])])]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Order Details"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 br_right"
  }, [_c('table', {
    staticClass: "table table-responsive custom_table_style"
  }, [_c('thead', [_c('th', [_vm._v("Client Order ID/Reference number :")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s(_vm.OrderDetails.OrderNo) + " ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Number of Pieces : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.OrderDetails.Quantity))]), _vm._v("    \n                        ")]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Total Invoice Value : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.OrderDetails.TotalInvoiceValue))]), _vm._v("    \n                        ")]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Topay (FTC) Amount : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.OrderDetails.ToPayFTCamount))]), _vm._v("\n                              \n                        ")]), _vm._v(" "), (_vm.SelectTypeOptionObj.value == 'ShippingID') ? _c('thead', [_c('th', [_vm._v("MPS Value :")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.OrderDetails.CollectibleAmount))]), _vm._v("\n                              \n                          \n                        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  }, [_c('table', {
    staticClass: "table table-responsive custom_table_style"
  }, [_c('thead', [_c('th', [_vm._v("Client Reference No : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s(_vm.OrderDetails.ClientReferenceNo) + " ")]), _vm._v("\n                               \n                        ")]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Order Type : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s(_vm.OrderDetails.OrderType) + " ")]), _vm._v("\n                               \n                        ")]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Product Type : ")]), _vm._v(" "), (_vm.OrderDetails.ProductType.length > 0) ? _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.OrderDetails.ProductType[0].SKU))]) : _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v("NA")]), _vm._v("\n\n                               \n                          "), (_vm.OrderDetails.ProductType.length > 1) ? _c('th', [_c('button', {
    staticClass: "btn btn-primary middleButton cst_btnT",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showProductType()
      }
    }
  }, [_vm._v(" View More")])]) : _vm._e()]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("RTO AWB:")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s(_vm.OrderDetails.RTOAWB) + " ")]), _vm._v("\n                               \n                        ")])])])])])]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Product Dimensions"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 br_right"
  }, [_c('table', {
    staticClass: "table table-responsive custom_table_style"
  }, [_c('thead', [_c('th', [_vm._v("Volumetric Weight :")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.OrderDetails.PackageDetails.Weight.VolWeight) + "\n                            " + _vm._s(_vm.OrderDetails.PackageDetails.Weight.Unit) + "\n                          ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Physical Weight : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.OrderDetails.PackageDetails.Weight.PhyWeight) + "\n                            " + _vm._s(_vm.OrderDetails.PackageDetails.Weight.Unit) + "\n                          ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Chargeable Weight : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.OrderDetails.PackageDetails.Weight.BillableWeight) + "\n                            " + _vm._s(_vm.OrderDetails.PackageDetails.Weight.Unit) + "\n                          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  }, [(_vm.SelectTypeOptionObj.value === 'ParentAWB') ? _c('span', [_c('th', {
    staticStyle: {
      "font-weight": "500",
      "vertical-align": "middle"
    }
  })]) : _c('span', [_c('table', {
    staticClass: "table table-responsive custom_table_style"
  }, [_c('thead', [_c('th', [_vm._v("Width : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.OrderDetails.PackageDetails.Dimensions.Width) + "\n                              " + _vm._s(_vm.OrderDetails.PackageDetails.Dimensions.Unit) + "\n                            ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Height : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.OrderDetails.PackageDetails.Dimensions.Height) + "\n                              " + _vm._s(_vm.OrderDetails.PackageDetails.Dimensions.Unit) + "\n                            ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Length : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.OrderDetails.PackageDetails.Dimensions.Length) + "\n                              " + _vm._s(_vm.OrderDetails.PackageDetails.Dimensions.Unit) + "\n                            ")])])])])])])])]), _vm._v(" "), (_vm.SalesDemo.BusinessType === 'BFSI' || _vm.CustomerAlternateAddress.Name || _vm.CustomerAlternateAddress.Address) ? _c('b-tab', {
    attrs: {
      "title": "Alternate Address"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 br_right"
  }, [_c('table', {
    staticClass: "table table-responsive custom_table_style"
  }, [_c('thead', [_c('th', [_vm._v("Name : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.CustomerAlternateAddress.Name))]), _vm._v("    \n                        ")]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Address : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s(_vm.CustomerAlternateAddress.Address) + " ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  }, [_c('table', {
    staticClass: "table table-responsive custom_table_style"
  }, [_c('thead', [_c('th', [_vm._v("City : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.CustomerAlternateAddress.City))]), _vm._v("    \n                        ")]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("State : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.CustomerAlternateAddress.State))]), _vm._v("    \n                        ")]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Pin Code : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.CustomerAlternateAddress.PinCode))]), _vm._v("\n                              \n                        ")])])])])])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.SalesDemo.BusinessFlow == 'Reverse') ? _c('b-tabs', [_c('b-tab', {
    attrs: {
      "title": "Current Status"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "title_txt"
  }, [(_vm.displayCurrentLocation && _vm.deliveryUserID) ? _c('span', [_c('h6', [_vm._v(" " + _vm._s(_vm.SalesDemo.UserProcess) + " By\n                        " + _vm._s(_vm.OrderDetails.srUserData.FirstName + ' ' + _vm.OrderDetails.srUserData.LastName) + "\n                      ")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-phone popup",
    on: {
      "click": _vm.myPopupFunction
    }
  }, [_c('span', {
    staticClass: "popuptext",
    attrs: {
      "id": "myPopup"
    }
  }, [_vm._v("+91-" + _vm._s(_vm.OrderDetails.srUserData.MobileNumber))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 br_right"
  }, [_c('table', {
    staticClass: "table table-responsive custom_table_style"
  }, [_c('thead', [_c('th', [_vm._v("Last NPR : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.ShipmentTransactionLogSummary.lastNDRUserProcess) + "\n                            " + _vm._s(_vm.ShipmentTransactionLogSummary.LastNDRDate) + "\n                          ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Notification Type :")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s(_vm.SalesDemo.NotificationType) + " ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Notification Status :")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s(_vm.SalesDemo.NotificationStatus) + " ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  }, [_c('table', {
    staticClass: "table table-responsive custom_table_style"
  }, [_c('thead', [_c('th', [_vm._v("Total Attempts :")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s(_vm.SalesDemo.TotalAttemptCount) + " ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Reattempt Date :")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s(_vm.SalesDemo.ReattemptDate) + " ")])])])])])])]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Product Details"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 br_right"
  }, [_c('table', {
    staticClass: "table table-responsive custom_table_style"
  }, [_c('thead', [_c('th', [_vm._v("Product Name : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.OrderDetails.ProductName))]), _vm._v("    \n                        ")]), _vm._v(" "), _c('thead', [(_vm.DepartmentID == '5') ? _c('span', [_c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }), _vm._v("    \n                          ")]) : _c('span', [_c('th', [_vm._v("Product Id : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s(_vm.OrderDetails.ProductID) + " ")]), _vm._v("    \n                          ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("POID : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.OrderDetails.POID))]), _vm._v("    \n                        ")]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Product Qty : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s(_vm.OrderDetails.Quantity) + " ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  }, [_c('table', {
    staticClass: "table table-responsive custom_table_style"
  }, [_c('thead', [_c('th', [_vm._v("Return reason : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.OrderDetails.ReturnReason))]), _vm._v("    \n                        ")]), _vm._v(" "), _c('thead', [(_vm.DepartmentID == '5') ? _c('span', [_c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }), _vm._v("    \n                          ")]) : _c('span', [_c('th', [_vm._v("Net Amount : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.OrderDetails.DeclaredValue))]), _vm._v("    \n                          ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Pickup Item Count : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.SalesDemo.TotalAttemptCount))]), _vm._v("    \n                        ")]), _vm._v(" "), _c('thead', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.MultipleProductInfo.MultipleProductInfoArr.length > 1),
      expression: "MultipleProductInfo.MultipleProductInfoArr.length > 1"
    }]
  }, [_c('th', [_c('button', {
    staticClass: "btn btn-primary cst_btnT",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showMultipleProductInfoModal()
      }
    }
  }, [_vm._v("Product Info\n                            ")])])])])])])])]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Product Dimensions"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 br_right"
  }, [_c('table', {
    staticClass: "table table-responsive custom_table_style"
  }, [_c('thead', [_c('th', [_vm._v("Volumetric Weight :")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.OrderDetails.PackageDetails.Weight.VolWeight) + "\n                            " + _vm._s(_vm.OrderDetails.PackageDetails.Weight.Unit) + "\n                          ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Physical Weight : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.OrderDetails.PackageDetails.Weight.PhyWeight) + "\n                            " + _vm._s(_vm.OrderDetails.PackageDetails.Weight.Unit) + "\n                          ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Chargeable Weight : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.OrderDetails.PackageDetails.Weight.BillableWeight) + "\n                            " + _vm._s(_vm.OrderDetails.PackageDetails.Weight.Unit) + "\n                          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  }, [_c('table', {
    staticClass: "table table-responsive custom_table_style"
  }, [_c('thead', [_c('th', [_vm._v("Width : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.OrderDetails.PackageDetails.Dimensions.Width) + "\n                            " + _vm._s(_vm.OrderDetails.PackageDetails.Dimensions.Unit) + "\n                          ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Height : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.OrderDetails.PackageDetails.Dimensions.Height) + "\n                            " + _vm._s(_vm.OrderDetails.PackageDetails.Dimensions.Unit) + "\n                          ")])]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Length : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.OrderDetails.PackageDetails.Dimensions.Length) + "\n                            " + _vm._s(_vm.OrderDetails.PackageDetails.Dimensions.Unit) + "\n                          ")])])])])])])]), _vm._v(" "), (_vm.SalesDemo.BusinessType === 'BFSI' || _vm.CustomerAlternateAddress.Name || _vm.CustomerAlternateAddress.Address) ? _c('b-tab', {
    attrs: {
      "title": "Alternate Address"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 br_right"
  }, [_c('table', {
    staticClass: "table table-responsive custom_table_style"
  }, [_c('thead', [_c('th', [_vm._v("Name : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.CustomerAlternateAddress.Name))]), _vm._v("    \n                        ")]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Address : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s(_vm.CustomerAlternateAddress.Address) + " ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  }, [_c('table', {
    staticClass: "table table-responsive custom_table_style"
  }, [_c('thead', [_c('th', [_vm._v("City : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.CustomerAlternateAddress.City))]), _vm._v("    \n                        ")]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("State : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.CustomerAlternateAddress.State))]), _vm._v("    \n                        ")]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Pin Code : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.CustomerAlternateAddress.PinCode))]), _vm._v("\n                              \n                        ")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.SalesDemo.BusinessType === 'BFSI' || _vm.CustomerAlternateAddress.Name || _vm.CustomerAlternateAddress.Address) ? _c('b-tab', {
    attrs: {
      "title": "Alternate Address"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 br_right"
  }, [_c('table', {
    staticClass: "table table-responsive custom_table_style"
  }, [_c('thead', [_c('th', [_vm._v("Name : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.CustomerAlternateAddress.Name))]), _vm._v("    \n                        ")]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Address : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(" " + _vm._s(_vm.CustomerAlternateAddress.Address) + " ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  }, [_c('table', {
    staticClass: "table table-responsive custom_table_style"
  }, [_c('thead', [_c('th', [_vm._v("City : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.CustomerAlternateAddress.City))]), _vm._v("    \n                        ")]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("State : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.CustomerAlternateAddress.State))]), _vm._v("    \n                        ")]), _vm._v(" "), _c('thead', [_c('th', [_vm._v("Pin Code : ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.CustomerAlternateAddress.PinCode))]), _vm._v("\n                              \n                        ")])])])])])]) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 "
  }, [_c('loading', {
    attrs: {
      "active": _vm.OtherShipments.isLoading,
      "is-full-page": false
    },
    on: {
      "update:active": function($event) {
        _vm.OtherShipments.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body  top_info_bodyT"
  }, [_c('div', {
    staticStyle: {
      "height": "250px"
    }
  }, [(_vm.OtherShipments.showChart) ? _c('DoughnutChart', {
    attrs: {
      "data": _vm.OtherShipments.chartData,
      "options": {
        responsive: true,
        maintainAspectRatio: false
      }
    }
  }) : _vm._e()], 1)])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.RaiseTicketDiv),
      expression: "RaiseTicketDiv"
    }],
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12",
    staticStyle: {
      "margin-top": "-10px"
    },
    attrs: {
      "id": "RaiseTicketDivUp"
    }
  }, [_c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    staticClass: "child"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "close_cross",
    on: {
      "click": function($event) {
        _vm.RaiseTicketDiv = false;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('h5', {
    staticClass: "ticketDiv"
  }, [_vm._v("MPS Details")]), _vm._v(" "), (_vm.tableShipment == false) ? _c('label', {
    staticClass: "totalRecordLabel"
  }, [_vm._v(" Total Records :\n                      " + _vm._s(_vm.AllShipmentLogArrData.length))]) : _vm._e(), _vm._v(" "), (_vm.tableShipment == false) ? _c('div', {
    staticClass: "form-group shipmentDropDownSelect"
  }, [_c('label', [_vm._v("Shipment Category :")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.arrayofobj,
      "selected-option": _vm.categoryOptionObj,
      "placeholder": "Select Search Type"
    },
    on: {
      "select": _vm.selectedOptionObj
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tableShipment == true) ? _c('div', {
    staticClass: "act_panel"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.ticketLabel == 'Raise Ticket' ? 'tableFixHead' : ''
  }, [(_vm.tableShipment == false) ? _c('table', {
    staticClass: "table table-responsive table-bordered tableFixHeadBottom"
  }, [_c('thead', {
    staticClass: "table-head"
  }, [(_vm.SelectTypeOptionObj.value == 'ParentAWB') ? _c('th', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allSelected),
      expression: "allSelected"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.checkAllSelected,
      "name": "Select All"
    },
    domProps: {
      "checked": Array.isArray(_vm.allSelected) ? _vm._i(_vm.allSelected, null) > -1 : (_vm.allSelected)
    },
    on: {
      "click": function($event) {
        _vm.byDefaultSelectAll($event)
      },
      "__c": function($event) {
        var $$a = _vm.allSelected,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.allSelected = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.allSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.allSelected = $$c
        }
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.SelectTypeOptionObj.value == 'ShippingID') ? _c('th', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allSelected),
      expression: "allSelected"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.checkAllSelected,
      "name": "Select All"
    },
    domProps: {
      "checked": Array.isArray(_vm.allSelected) ? _vm._i(_vm.allSelected, null) > -1 : (_vm.allSelected)
    },
    on: {
      "click": function($event) {
        _vm.selectAll($event)
      },
      "__c": function($event) {
        var $$a = _vm.allSelected,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.allSelected = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.allSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.allSelected = $$c
        }
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', [_vm._v("View Log")]), _vm._v(" "), _c('th', [_vm._v("Manifest Date")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Shipment Status")]), _vm._v(" "), _c('th', [_vm._v("Origin")]), _vm._v(" "), _c('th', [_vm._v("Current Location")]), _vm._v(" "), _c('th', [_vm._v("Destination")]), _vm._v(" "), _c('th', [_vm._v("Attempts")]), _vm._v(" "), _c('th', [_vm._v("Reattempt Date")]), _vm._v(" "), _c('th', [_vm._v("Appointment Date")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.AllShipmentLogArrData), function(OtherShipmentLogTblEle, index) {
    return (_vm.OtherShipmentLogCnt > 0) ? _c('tr', [(_vm.SelectTypeOptionObj.value == 'ParentAWB') ? _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.OtherShipmentShippingIDCheckedArr),
        expression: "OtherShipmentShippingIDCheckedArr"
      }],
      staticStyle: {
        "margin-left": "6px"
      },
      attrs: {
        "id": OtherShipmentLogTblEle.ShippingID,
        "checked": "true",
        "type": "checkbox",
        "name": "Select All"
      },
      domProps: {
        "value": OtherShipmentLogTblEle.ShippingID,
        "checked": Array.isArray(_vm.OtherShipmentShippingIDCheckedArr) ? _vm._i(_vm.OtherShipmentShippingIDCheckedArr, OtherShipmentLogTblEle.ShippingID) > -1 : (_vm.OtherShipmentShippingIDCheckedArr)
      },
      on: {
        "click": function($event) {
          _vm.byDefaultSelectAll($event)
        },
        "__c": function($event) {
          var $$a = _vm.OtherShipmentShippingIDCheckedArr,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = OtherShipmentLogTblEle.ShippingID,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.OtherShipmentShippingIDCheckedArr = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.OtherShipmentShippingIDCheckedArr = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.OtherShipmentShippingIDCheckedArr = $$c
          }
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.SelectTypeOptionObj.value == 'ShippingID') ? _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.OtherShipmentShippingIDCheckedArr),
        expression: "OtherShipmentShippingIDCheckedArr"
      }],
      staticStyle: {
        "margin-left": "6px"
      },
      attrs: {
        "id": OtherShipmentLogTblEle.ShippingID,
        "checked": "true",
        "type": "checkbox",
        "name": "Select All"
      },
      domProps: {
        "value": OtherShipmentLogTblEle.ShippingID,
        "checked": Array.isArray(_vm.OtherShipmentShippingIDCheckedArr) ? _vm._i(_vm.OtherShipmentShippingIDCheckedArr, OtherShipmentLogTblEle.ShippingID) > -1 : (_vm.OtherShipmentShippingIDCheckedArr)
      },
      on: {
        "click": function($event) {
          _vm.select(OtherShipmentLogTblEle, index, $event)
        },
        "__c": function($event) {
          var $$a = _vm.OtherShipmentShippingIDCheckedArr,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = OtherShipmentLogTblEle.ShippingID,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.OtherShipmentShippingIDCheckedArr = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.OtherShipmentShippingIDCheckedArr = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.OtherShipmentShippingIDCheckedArr = $$c
          }
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(OtherShipmentLogTblEle.ShippingID))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "color": "blue",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.showShipmentLogModal(OtherShipmentLogTblEle.ShippingID)
        }
      }
    }, [_vm._v("View Log")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(OtherShipmentLogTblEle.CreatedDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(OtherShipmentLogTblEle.Status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(OtherShipmentLogTblEle.CurrentStatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(OtherShipmentLogTblEle.OriginHubID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(OtherShipmentLogTblEle.CurrentHubID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(OtherShipmentLogTblEle.FinalDestinationID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(OtherShipmentLogTblEle.TotalAttemptCount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(OtherShipmentLogTblEle.ReattemptDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(OtherShipmentLogTblEle.AppointmentDate))])]) : _vm._e()
  }))]) : _vm._e()])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Raise Ticket")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 tickeTopDiv"
  }, [_c('form', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [(_vm.ticketTaggingDisplay == true) ? _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "50px"
    }
  }, [_vm._v("Search Tagging : ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.searchOptions,
      "selected-option": _vm.selectedSearchObj,
      "placeholder": "Search Tagging"
    },
    on: {
      "select": _vm.selectedSearchTag
    },
    model: {
      value: (_vm.searchId),
      callback: function($$v) {
        _vm.searchId = $$v
      },
      expression: "searchId"
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.ticketTaggingDisplay == false && _vm.mobileNo != null) && (_vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM || this.selectedActionObj.value == _vm.ADDRESS_UPDATED)) ? _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "50px"
    }
  }, [_vm._v("Primary No : ")]), _vm._v(" "), _c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|digits:10'),
      expression: "'required|digits:10'"
    }],
    staticStyle: {
      "width": "60%",
      "float": "right",
      "margin-right": "60px"
    },
    attrs: {
      "name": "mobileNo",
      "placeholder": ""
    },
    model: {
      value: (_vm.mobileNo),
      callback: function($$v) {
        _vm.mobileNo = $$v
      },
      expression: "mobileNo"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('mobileNo')),
      expression: "errors.has('mobileNo')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('mobileNo')),
      expression: "errors.has('mobileNo')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('mobileNo')))])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "95px"
    }
  }, [_vm._v("Source "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.source,
      "selected-option": _vm.selectedSourceObj,
      "placeholder": "Select Source"
    },
    on: {
      "select": _vm.selectedSource
    },
    model: {
      value: (_vm.sourceId),
      callback: function($$v) {
        _vm.sourceId = $$v
      },
      expression: "sourceId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "68px"
    }
  }, [_vm._v("Ticket Type "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.ticketType,
      "selected-option": _vm.selectedTicketObj,
      "placeholder": "Select Ticket"
    },
    on: {
      "select": _vm.selectedTicket
    },
    model: {
      value: (_vm.ticketTypeId),
      callback: function($$v) {
        _vm.ticketTypeId = $$v
      },
      expression: "ticketTypeId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "92px"
    }
  }, [_vm._v("Reason "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('basic-select', {
    staticStyle: {
      "width": "60.3%"
    },
    attrs: {
      "options": _vm.reason,
      "selected-option": _vm.selectedReasonObj,
      "placeholder": "Select Reason"
    },
    on: {
      "select": _vm.selectedReason
    },
    model: {
      value: (_vm.reasonId),
      callback: function($$v) {
        _vm.reasonId = $$v
      },
      expression: "reasonId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "65px"
    }
  }, [_vm._v("Sub Reason "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.subReason,
      "name": "subReasonId",
      "selected-option": _vm.selectedSubReasonObj,
      "placeholder": "Select Sub Reason"
    },
    on: {
      "select": _vm.selectedSubReason
    },
    model: {
      value: (_vm.subReasonId),
      callback: function($$v) {
        _vm.subReasonId = $$v
      },
      expression: "subReasonId"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('subReasonId')),
      expression: "errors.has('subReasonId')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('subReasonId')),
      expression: "errors.has('subReasonId')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('subReasonId')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "19px"
    }
  }, [_vm._v(" Resolution / Action "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.action,
      "placeholder": "Select Action",
      "selected-option": _vm.selectedActionObj
    },
    on: {
      "select": _vm.selectedAction
    },
    model: {
      value: (_vm.actionId),
      callback: function($$v) {
        _vm.actionId = $$v
      },
      expression: "actionId"
    }
  })], 1), _vm._v(" "), ((_vm.selectedSubReasonObj.text == 'Change RTO address' || _vm.selectedSubReasonObj.text == 'Change delivery address' || _vm.selectedSubReasonObj.text == 'Change delivery address as per Client' || _vm.selectedSubReasonObj.text == 'Change DTO address' || _vm.selectedSubReasonObj.text == 'Change Pickup address' || _vm.selectedSubReasonObj.text == 'Redirect to Bank') && (_vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM || _vm.selectedActionObj.value == _vm.ADDDESS_CHANGE_REQUESTED || _vm.selectedActionObj.value == _vm.ADDRESS_UPDATED) || _vm.selectedSubReasonObj.text == 'Change destination as per Client') ? _c('div', {
    staticStyle: {
      "margin-bottom": "20px",
      "display": "flex",
      "align-items": "right"
    }
  }, [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "95px"
    }
  }, [_vm._v("Address"), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('b-form-textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:3|max:200'),
      expression: "'required|min:3|max:200'"
    }],
    staticClass: "myplace",
    staticStyle: {
      "width": "60%",
      "border-radius": "5px",
      "border-color": "#ddd"
    },
    attrs: {
      "name": "address",
      "placeholder": "Enter Address",
      "rows": "4",
      "max-rows": "6",
      "id": "address-textarea"
    },
    model: {
      value: (_vm.address),
      callback: function($$v) {
        _vm.address = $$v
      },
      expression: "address"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('address')),
      expression: "errors.has('address')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('address')),
      expression: "errors.has('address')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('address')))])], 1) : _vm._e(), _vm._v(" "), ((_vm.selectedSubReasonObj.text == 'Change RTO address' || _vm.selectedSubReasonObj.text == 'Change delivery address' || _vm.selectedSubReasonObj.text == 'Change delivery address as per Client' ||
      _vm.selectedSubReasonObj.text == 'Change DTO address' || _vm.selectedSubReasonObj.text == 'Change Pickup address' ||
      _vm.selectedSubReasonObj.text == 'Change misroute pincode' || _vm.selectedSubReasonObj.text == 'Redirect to Bank' ||
      _vm.selectedSubReasonObj.value == _vm.CHANGE_RTO_PINCODE || _vm.selectedSubReasonObj.value == _vm.CHANGE_DELIVERY_PINCODE ||
      _vm.selectedSubReasonObj.value == _vm.CHANGE_DTO_PINCODE || _vm.selectedSubReasonObj.value == _vm.CHANGE_PICKUP_PINCODE) &&
    (_vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM || _vm.selectedActionObj.value == _vm.ADDDESS_CHANGE_REQUESTED ||
      this.selectedActionObj.value == _vm.ADDRESS_UPDATED)) ? _c('div', {
    staticStyle: {
      "margin-bottom": "20px",
      "display": "flex",
      "align-items": "right"
    }
  }, [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "95px"
    }
  }, [_vm._v("PinCode"), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric|digits:6'),
      expression: "'required|numeric|digits:6'"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('pincode')
    },
    staticStyle: {
      "width": "60%",
      "border-radius": "5px",
      "border-color": "#ddd"
    },
    attrs: {
      "name": "pincode",
      "placeholder": "Enter PinCode"
    },
    model: {
      value: (_vm.pincode),
      callback: function($$v) {
        _vm.pincode = $$v
      },
      expression: "pincode"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pincode')),
      expression: "errors.has('pincode')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pincode')),
      expression: "errors.has('pincode')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('pincode')))])], 1) : _vm._e(), _vm._v(" "), (_vm.selectedSubReasonObj.text == 'Change destination as per Client') ? _c('div', {
    staticStyle: {
      "margin-bottom": "20px",
      "display": "flex",
      "align-items": "right"
    }
  }, [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "95px"
    }
  }, [_vm._v("PinCode"), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric|digits:6'),
      expression: "'required|numeric|digits:6'"
    }],
    staticClass: "myplace",
    class: {
      'input': true, 'is-danger': _vm.errors.has('pincode')
    },
    staticStyle: {
      "width": "60%",
      "border-radius": "5px",
      "border-color": "#ddd"
    },
    attrs: {
      "name": "pincode",
      "placeholder": "Enter PinCode"
    },
    on: {
      "change": function($event) {
        _vm.fetchHubDataFromPincode($event)
      }
    },
    model: {
      value: (_vm.pincode),
      callback: function($$v) {
        _vm.pincode = $$v
      },
      expression: "pincode"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pincode')),
      expression: "errors.has('pincode')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pincode')),
      expression: "errors.has('pincode')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('pincode')))])], 1) : _vm._e(), _vm._v(" "), ((((_vm.selectedReasonObj.text == 'SR related' && _vm.selectedSubReasonObj.text == 'Fake update') || _vm.selectedReasonObj.text == 'Arrange pickup' || _vm.selectedReasonObj.text == 'Arrange delivery' || (_vm.selectedReasonObj.text == 'Non Behavioral' && _vm.selectedSubReasonObj.text == 'Delay in service') || _vm.selectedSubReasonObj.value == _vm.FAKE_NDR || _vm.selectedSubReasonObj.value == _vm.REFUSED_DOORSTEP_DELIVERY ||
    _vm.selectedSubReasonObj.value == _vm.DELAY_IN_PICKUP_SUB_REASON || _vm.selectedSubReasonObj.value == _vm.FAKE_NPR ||
    _vm.selectedSubReasonObj.value == _vm.FAKE_PICKUP || _vm.selectedSubReasonObj.value == _vm.DENIED_PICKUP ||
    _vm.selectedSubReasonObj.value == _vm.CHANGE_REATTEMPT_DATE) && (_vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM || _vm.selectedActionObj.value == _vm.REATTEMPT_DATE_CHANGED || _vm.selectedActionObj.value == _vm.ATTEMPT_DELIVERY))) ? _c('div', {
    staticStyle: {
      "margin-bottom": "20px",
      "display": "flex",
      "align-items": "right"
    }
  }, [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "46px"
    }
  }, [_vm._v("Reattempt Date\n                              "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('date-picker', {
    staticStyle: {
      "margin-right": "75px"
    },
    attrs: {
      "lang": "en",
      "type": "date",
      "format": _vm.format,
      "not-before": _vm.startDate,
      "not-after": _vm.endDate
    },
    model: {
      value: (_vm.reAttemptDate),
      callback: function($$v) {
        _vm.reAttemptDate = $$v
      },
      expression: "reAttemptDate"
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.selectedSubReasonObj.value == _vm.Alternate_Instruction_Pickup || _vm.selectedSubReasonObj.value == _vm.Pickup_Details_Updates && _vm.selectedActionObj.value == _vm.Address_Updated)) ? _c('div', {
    staticStyle: {
      "margin-bottom": "20px",
      "display": "flex",
      "align-items": "right"
    }
  }, [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "50px"
    }
  }, [_vm._v("\n              Pickup Address "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(": \n            ")]), _vm._v(" "), _c('b-form-textarea', {
    staticClass: "myplace",
    staticStyle: {
      "width": "60%",
      "border-radius": "5px",
      "border-color": "#ddd"
    },
    attrs: {
      "name": "pickupAddress",
      "placeholder": "Enter Address",
      "rows": "4",
      "max-rows": "6",
      "id": "address-textarea"
    },
    model: {
      value: (_vm.pickupAddress),
      callback: function($$v) {
        _vm.pickupAddress = $$v
      },
      expression: "pickupAddress"
    }
  })], 1) : _vm._e(), _vm._v(" "), ((
    (_vm.selectedReasonObj.value == _vm.Alternate_Instruction_Pickup || _vm.selectedReasonObj.value == _vm.Alternate_Instruction_Delivery) &&
    (_vm.selectedSubReasonObj.value == _vm.Reattempt_Time_Slot_Pickup || _vm.selectedSubReasonObj.value == _vm.Reattempt_Time_Slot_Delivery || _vm.selectedSubReasonObj.value == _vm.Hold_Pickup) &&
    (_vm.selectedActionObj.value == _vm.Attempt_Pickup || _vm.selectedActionObj.value == _vm.Attempt_Delivery)
  )) ? _c('div', {
    staticStyle: {
      "margin-bottom": "20px",
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('label', {
    staticClass: "date_time_label_text"
  }, [_vm._v("\n                " + _vm._s(_vm.dynamicTimeSlotLabel) + " "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" :\n              ")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "datetime",
      "format": 'YYYY-MM-DD HH:mm:ss',
      "confirm": true,
      "not-before": _vm.minSelectableDateTime,
      "not-after": _vm.maxSelectableDateTime,
      "disabled-time": _vm.disablePastTime,
      "editable": false
    },
    model: {
      value: (_vm.reattemptTimeSlotWithDate),
      callback: function($$v) {
        _vm.reattemptTimeSlotWithDate = $$v
      },
      expression: "reattemptTimeSlotWithDate"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectedReasonObj.value == _vm.Alternate_Instruction_Delivery &&
    _vm.selectedSubReasonObj.value == _vm.Contact_Updated &&
    _vm.selectedActionObj.value == _vm.Updated_Contact) ? _c('div', {
    staticStyle: {
      "margin-bottom": "20px",
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('label', {
    staticClass: "contact_label_text"
  }, [_vm._v("Contact Number "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('b-form-input', {
    staticStyle: {
      "width": "60%",
      "border-radius": "5px",
      "border-color": "#ddd"
    },
    attrs: {
      "name": "contactNumber",
      "placeholder": "Enter Contact Number"
    },
    model: {
      value: (_vm.contactNumber),
      callback: function($$v) {
        _vm.contactNumber = $$v
      },
      expression: "contactNumber"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectedSubReasonObj.text == 'Change payment mode / amount') ? _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('label', {
    staticClass: "label_text"
  }, [_vm._v("Payment Method : ")]), _vm._v(" "), _c('basic-select', {
    staticStyle: {
      "width": "60.3%"
    },
    attrs: {
      "options": _vm.payMethods,
      "selected-option": _vm.selectedMethodObj,
      "placeholder": "Select Payment Method",
      "isDisabled": _vm.disPaymentMethod
    },
    on: {
      "select": _vm.selectedMethod
    },
    model: {
      value: (_vm.methodId),
      callback: function($$v) {
        _vm.methodId = $$v
      },
      expression: "methodId"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('methodId')),
      expression: "errors.has('methodId')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('methodId')),
      expression: "errors.has('methodId')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('methodId')))])], 1) : _vm._e(), _vm._v(" "), (_vm.selectedSubReasonObj.text == 'Change destination as per Client') ? _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "75px"
    }
  }, [_vm._v("Select Hub"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.hubList,
      "selected-option": _vm.selectedHubObj,
      "name": "hubIds",
      "placeholder": "Select Hub Id"
    },
    on: {
      "select": _vm.selectedHub
    },
    model: {
      value: (_vm.hubIds),
      callback: function($$v) {
        _vm.hubIds = $$v
      },
      expression: "hubIds"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('hubIds')),
      expression: "errors.has('hubIds')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('hubIds')),
      expression: "errors.has('hubIds')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('hubIds')))])], 1) : _vm._e(), _vm._v(" "), (_vm.selectedSubReasonObj.text == 'Change payment mode / amount' && _vm.orderTypeId == 'CashOnDelivery' && (_vm.selectedActionObj.value == _vm.STATUS_CHANGED || _vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM || _vm.selectedActionObj.value == _vm.PAYMENT_DETAILS_CHANGE_REQUESTED)) ? _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('label', {
    staticClass: "label_text"
  }, [_vm._v("Net Payment : ")]), _vm._v(" "), _c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|decimal:2|between:1,10000000'),
      expression: "'required|decimal:2|between:1,10000000'"
    }],
    staticStyle: {
      "width": "60%",
      "float": "right",
      "margin-right": "45px"
    },
    attrs: {
      "name": "netPayment",
      "placeholder": "",
      "disabled": _vm.disPayment
    },
    model: {
      value: (_vm.netPayment),
      callback: function($$v) {
        _vm.netPayment = $$v
      },
      expression: "netPayment"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('netPayment')),
      expression: "errors.has('netPayment')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('netPayment')),
      expression: "errors.has('netPayment')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('netPayment')))])], 1) : _vm._e(), _vm._v(" "), (_vm.selectedSubReasonObj.text == 'Update Amount') ? _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('label', {
    staticClass: "label_text"
  }, [_vm._v("Net Payment "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(": ")]), _vm._v(" "), _c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|decimal:2|between:1,10000000'),
      expression: "'required|decimal:2|between:1,10000000'"
    }],
    staticStyle: {
      "width": "59%",
      "float": "right",
      "margin-right": "70px"
    },
    attrs: {
      "name": "netPayment",
      "placeholder": "",
      "disabled": _vm.disPayment
    },
    model: {
      value: (_vm.netPayment),
      callback: function($$v) {
        _vm.netPayment = $$v
      },
      expression: "netPayment"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('netPayment')),
      expression: "errors.has('netPayment')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('netPayment')),
      expression: "errors.has('netPayment')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('netPayment')))])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "70%",
      "float": "right"
    }
  }, [((_vm.ticketTaggingDisplay == false && _vm.reasonId == _vm.ADDRESS_CHANGE && _vm.ticket.comments != null && _vm.ticket.comments != '') && (_vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM || this.selectedActionObj.value == _vm.ADDRESS_UPDATED)) ? _c('div', [_c('label', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("Previous Comments : ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "60%",
      "height": "90px",
      "float": "right",
      "box-sizing": "border-box",
      "border": "1px solid rgba(216, 212, 212, 0.89)",
      "padding": "10px",
      "margin-right": "60px"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.ticket.comments))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "70%",
      "float": "right"
    }
  }, [(((_vm.selectedSubReasonObj.value == _vm.UPDATE_ALTERNATE_CONTACT_NO && (_vm.selectedActionObj.value == _vm.CONTACT_DETAILS_UPDATED || _vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM)) ||
    ((_vm.selectedSubReasonObj.text == 'Change RTO address' || _vm.selectedSubReasonObj.text == 'Change delivery address' || _vm.selectedSubReasonObj.text == 'Change delivery address as per Client' ||
      _vm.selectedSubReasonObj.text == 'Change DTO address' || _vm.selectedSubReasonObj.text == 'Change Pickup address' ||
      _vm.selectedSubReasonObj.text == 'Redirect to Bank') && _vm.ticketTaggingDisplay == false && _vm.alternateContactNo != null && (_vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM || this.selectedActionObj.value == _vm.ADDRESS_UPDATED)))) ? _c('div', [_c('label', {
    staticClass: "label_text"
  }, [_vm._v("Alternate No : ")]), _vm._v(" "), _c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|digits:10|min:10|max:10'),
      expression: "'required|digits:10|min:10|max:10'"
    }],
    staticStyle: {
      "width": "60%",
      "float": "right",
      "margin-right": "59px"
    },
    attrs: {
      "name": "alternateContactNo",
      "placeholder": ""
    },
    model: {
      value: (_vm.alternateContactNo),
      callback: function($$v) {
        _vm.alternateContactNo = $$v
      },
      expression: "alternateContactNo"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('alternateContactNo')),
      expression: "errors.has('alternateContactNo')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('alternateContactNo')),
      expression: "errors.has('alternateContactNo')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('alternateContactNo')))])], 1) : _vm._e(), _vm._v(" "), ((_vm.selectedSubReasonObj.value == _vm.UPDATE_EMAIL_ADDRESS && (_vm.selectedActionObj.value == _vm.CONTACT_DETAILS_UPDATED || _vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM))) ? _c('div', [_c('label', {
    staticClass: "label_text"
  }, [_vm._v("Email Address : ")]), _vm._v(" "), _c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticStyle: {
      "width": "60%",
      "float": "right",
      "margin-right": "59px"
    },
    attrs: {
      "name": "emailAddress",
      "placeholder": "Email Address"
    },
    model: {
      value: (_vm.emailAddress),
      callback: function($$v) {
        _vm.emailAddress = $$v
      },
      expression: "emailAddress"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('emailAddress')),
      expression: "errors.has('emailAddress')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('emailAddress')),
      expression: "errors.has('emailAddress')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('emailAddress')))])], 1) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', [_c('label', {
    staticClass: "label_text",
    staticStyle: {
      "margin-right": "56px"
    }
  }, [_vm._v("Ticket Status "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.ticketStatus,
      "placeholder": "Select Ticket Status",
      "selected-option": _vm.selectedTicketStatusObj
    },
    on: {
      "select": _vm.selectedTicketStatus
    },
    model: {
      value: (_vm.ticketStatusId),
      callback: function($$v) {
        _vm.ticketStatusId = $$v
      },
      expression: "ticketStatusId"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-8"
  }, [_c('label', {
    staticClass: "label_text"
  }, [_vm._v("Comments "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('b-form-textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min:3|max:300'),
      expression: "'min:3|max:300'"
    }],
    staticStyle: {
      "max-height": "100px"
    },
    attrs: {
      "placeholder": "",
      "rows": "4",
      "max-rows": "6"
    },
    model: {
      value: (_vm.comments),
      callback: function($$v) {
        _vm.comments = $$v
      },
      expression: "comments"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "commentErrMsgCss"
  }, [_vm._v("Maximum 300 characters allowed.")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('comments')),
      expression: "errors.has('comments')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('comments')),
      expression: "errors.has('comments')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('comments')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form_btn",
    staticStyle: {
      "position": "relative",
      "top": "94px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "disabled": _vm.validatedSave ? '' : _vm.ticket.disabled || _vm.errors.any()
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.saveTicketDataClick($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")]), _vm._v(" "), (_vm.ticketTaggingDisplay == true) ? _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resetForm($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")]) : _vm._e()])])])])])])])])], 1)])], 1) : _vm._e()]), _vm._v(" "), (_vm.MobileNumberTypeMainDiv) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    staticClass: "child"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tableFixHead"
  }, [_c('table', {
    staticClass: "table table-responsive table-bordered tableFixHeadBottom "
  }, [_c('thead', [_c('th', [_vm._v("Created Date")]), _vm._v(" "), _c('th', [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', [_vm._v("Business Flow")]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Current Status")]), _vm._v(" "), _c('th', [_vm._v("Attempts")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.OtherShipmentLogArr), function(OtherShipmentLogTblEle, index) {
    return (_vm.OtherShipmentLogCnt > 0) ? _c('tr', [_c('td', [_vm._v(_vm._s(OtherShipmentLogTblEle.CreatedDate))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'trackshipmentsummarydetail',
          params: {
            id: OtherShipmentLogTblEle.ShippingID
          }
        },
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(OtherShipmentLogTblEle.ShippingID))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(OtherShipmentLogTblEle.BusinessFlow))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(OtherShipmentLogTblEle.ClientName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(OtherShipmentLogTblEle.Status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(OtherShipmentLogTblEle.CurrentStatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(OtherShipmentLogTblEle.TotalAttemptCount))])]) : _vm._e()
  }))])])], 1)])])])])], 1)])]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    model: {
      value: (_vm.BagNoObj.TransitStatusModal),
      callback: function($$v) {
        _vm.BagNoObj.TransitStatusModal = $$v
      },
      expression: "BagNoObj.TransitStatusModal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.BagNoObj.TransitStatusModal),
      expression: "BagNoObj.TransitStatusModal"
    }],
    staticClass: "col-lg-12",
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('b-card', {
    staticStyle: {
      "background-color": "transparent",
      "border": "0px solid transparent"
    }
  }, [_c('span', [_c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Paper Work ")]), _vm._v(" "), _c('h6', {
    staticStyle: {
      "display": "inline",
      "position": "relative",
      "left": "25%"
    }
  }, [_vm._v("Parent AWB : " + _vm._s(_vm.ParentAWBNo))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeBModalCommonFunction('TransitStatusModal')
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row rowFullTable"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tableFixHead"
  }, [_c('table', {
    staticClass: "table table-responsive table-bordered tableFixHeadBottom"
  }, [_c('thead', [_c('th', [_vm._v("Paper Bag No")]), _vm._v(" "), _c('th', [_vm._v("Paper Bag Status")]), _vm._v(" "), _c('th', [_vm._v("Source Hub Name")]), _vm._v(" "), _c('th', [_vm._v("Current Hub Name")]), _vm._v(" "), _c('th', [_vm._v("Destination Hub Name")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.BagNoObj.TransitStatusArr), function(RowEle, index) {
    return (_vm.BagNoObj.TransitStatusArr.length > 0) ? _c('tr', [_c('td', [_vm._v(_vm._s(RowEle.paperbagno))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(RowEle.paperbagstatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(RowEle.originhubname) + "(" + _vm._s(RowEle.originhubid) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(RowEle.currenthubname) + "(" + _vm._s(RowEle.currenthubid) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(RowEle.finaldestinationname))])]) : _vm._e()
  }))])])], 1)])])])], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    model: {
      value: (_vm.ShipmentLogModal),
      callback: function($$v) {
        _vm.ShipmentLogModal = $$v
      },
      expression: "ShipmentLogModal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ShipmentLogModal),
      expression: "ShipmentLogModal"
    }],
    staticClass: "col-lg-12",
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('b-card', {
    staticStyle: {
      "background-color": "transparent",
      "border": "0px solid transparent",
      "display": "inline-block",
      "margin-bottom": "0px",
      "width": "100%"
    },
    attrs: {
      "title": "Shipment Log"
    }
  }, [_c('button', {
    staticClass: "close",
    staticStyle: {
      "display": "inline",
      "position": "relative",
      "bottom": "40px"
    },
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeBModalCommonFunction('ShipmentLogModal')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h5', {
    staticClass: "ship_id_head",
    staticStyle: {
      "display": "inline",
      "position": "relative",
      "bottom": "40px",
      "left": "10%"
    }
  }, [_vm._v("Shipment : "), _c('span', {
    staticClass: "modal_ship_id"
  }, [_vm._v(_vm._s(_vm.mpsdetails1))])]), _vm._v(" "), _c('div', {
    staticClass: "card-body",
    staticStyle: {
      "padding-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "row rowFullTableT"
  }, [_c('div', {
    staticClass: "col-sm-12 col-xs-12 col-md-12 col-lg-12 ShipmentLogDivT tableFixHeadTT",
    staticStyle: {
      "margin-top": "-30px!important"
    }
  }, [_c('div', {
    staticClass: "tableFixHead"
  }, [_c('table', {
    staticClass: "table table-responsive table-bordered tableFixHeadBottom"
  }, [_c('thead', {
    staticClass: "table-head"
  }, [_c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("Date")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("Process Location")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("Process")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("Comments")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Created By")])]), _vm._v(" "), _c('tbody', {
    staticClass: "table-body"
  }, _vm._l((_vm.sorArrtByDate(_vm.ShipmentLog.ShipmentLogBarArr)), function(ShipmentLogTblEle, index) {
    return (_vm.ShipmentLog.ShipmentLogCnt > 0) ? _c('tr', [_c('td', {
      staticStyle: {
        "max-width": "70px"
      }
    }, [_vm._v(_vm._s(ShipmentLogTblEle.CreatedDate))]), _vm._v(" "), (ShipmentLogTblEle.ClientBusinessAccountId == 0) ? _c('td', [_c('i', {
      staticClass: "fa fa-file-audio-o fa-warningT",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          _vm.getIVRCallRecordingUrl(("" + (ShipmentLogTblEle.ProcessCode)))
        }
      }
    })]) : _c('td', [_vm._v(_vm._s(ShipmentLogTblEle.ProcessLocation))]), _vm._v(" "), (ShipmentLogTblEle.BagNo) ? _c('td', [_vm._v(_vm._s(ShipmentLogTblEle.UserProcess) + "\n                        "), _c('br'), _vm._v(" (Bag No : " + _vm._s(ShipmentLogTblEle.BagNo) + ")\n                      ")]) : _c('td', [_vm._v(_vm._s(ShipmentLogTblEle.UserProcess))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ShipmentLogTblEle.Comments))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "max-width": "160px"
      }
    }, [_vm._v(_vm._s(ShipmentLogTblEle.UserName))])]) : _vm._e()
  }))])])])])])])], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    model: {
      value: (_vm.locationMapModal),
      callback: function($$v) {
        _vm.locationMapModal = $$v
      },
      expression: "locationMapModal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.locationMapModal),
      expression: "locationMapModal"
    }],
    staticClass: "col-lg-12"
  }, [_c('b-card', {
    staticStyle: {
      "background-color": "transparent",
      "border": "0px solid transparent"
    }
  }, [_c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Location Map")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeBModalCommonFunction('locationMapModal')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('div', {
    staticClass: "accordian-body",
    staticStyle: {
      "float": "left",
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "id": 'map' + _vm.ShippingID
    }
  })])])])])], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "no-enforce-focus": true
    },
    model: {
      value: (_vm.Ticketmodal),
      callback: function($$v) {
        _vm.Ticketmodal = $$v
      },
      expression: "Ticketmodal"
    }
  }, [_c('loading', {
    attrs: {
      "active": _vm.isModelLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isModelLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Ticketmodal),
      expression: "Ticketmodal"
    }],
    staticClass: "col-lg-12",
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('b-card', {
    staticStyle: {
      "background-color": "transparent",
      "border": "0px solid transparent"
    }
  }, [_c('h6', {
    staticClass: "modal-title",
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("Ticket History")]), _vm._v(" "), _c('h5', {
    staticClass: "ship_id_head"
  }, [_vm._v("Shipment Id : "), _c('span', {
    staticClass: "modal_ship_id"
  }, [_vm._v(_vm._s(_vm.ShippingID))])]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeBModalCommonFunction('Ticketmodal')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row rowFullTable"
  }, [_c('div', {
    staticClass: "col-sm-12 col-xs-12 col-md-6 col-lg-12"
  }, [(_vm.counter == 0) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [(_vm.filter.length == 0) ? _c('div', {
    staticClass: "search_bar"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "float": "right",
      "margin-right": "10px",
      "margin-bottom": "20px"
    },
    attrs: {
      "id": "btnSearch"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.OnFilterClick($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    ref: "search",
    staticClass: " form-control col-md-2",
    staticStyle: {
      "float": "right",
      "margin-right": "13px"
    },
    attrs: {
      "type": "text",
      "title": "Search by any column-name"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "keyup": _vm.OnFilterClick,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })]) : _c('div', {
    staticClass: "search_bar"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "float": "right",
      "margin-right": "10px",
      "margin-bottom": "20px"
    },
    attrs: {
      "id": "btnSearch"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.OnFilterClick($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: " form-control col-md-2",
    staticStyle: {
      "float": "right",
      "margin-right": "13px"
    },
    attrs: {
      "type": "text",
      "autofocus": "",
      "title": "Search by any column-name"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table table-responsive table-bordered"
  }, [_c('thead', {
    staticClass: "table-head"
  }, [_c('th', [_vm._v("Ticket ID")]), _vm._v(" "), _c('th', [_vm._v("Created Date")]), _vm._v(" "), _c('th', [_vm._v("Source")]), _vm._v(" "), _c('th', [_vm._v("Ticket Type")]), _vm._v(" "), _c('th', [_vm._v("Reason")]), _vm._v(" "), _c('th', [_vm._v("Sub Reason")]), _vm._v(" "), _c('th', [_vm._v("Resolution")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Created By")]), _vm._v(" "), _c('th', [_vm._v("Action")]), _vm._v(" "), _c('th', [_vm._v("Ticket Log")])]), _vm._v(" "), _c('tbody', {
    staticClass: "scrollDivCls"
  }, [_vm._l((_vm.shipmentTickets), function(ticket, index) {
    return (_vm.shipmentTickets.length > 0) ? _c('tr', [_c('td', [_vm._v(_vm._s(ticket.ticketid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatDatesingle")(ticket.createddate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ticket.source))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ticket.maintype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ticket.subtype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ticket.typename))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ticket.action))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ticket.ticketstatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ticket.createdby))]), _vm._v(" "), _c('td', [(ticket.ticketstatus != 'Closed' && ticket.action != 'RTO') ? _c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          _vm.editTicket(ticket)
        }
      }
    }, [_vm._v("Update")]) : _vm._e(), _vm._v(" "), (ticket.ticketstatus == 'Closed' && ticket.clientid != null && ticket.action != 'RTO') ? _c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          _vm.editTicket(ticket)
        }
      }
    }, [_vm._v("Reopen")]) : _vm._e(), _vm._v(" "), (ticket.ticketstatus == 'Open' && ticket.action == 'RTO') ? _c('button', {
      attrs: {
        "disabled": _vm.validated
      },
      on: {
        "click": function($event) {
          _vm.openUploadRTODocs(ticket)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-upload"
    }), _vm._v(" Upload RTO Documents")]) : _vm._e(), _vm._v(" "), (ticket.ticketstatus == 'Closed' && ticket.action == 'RTO') ? _c('button', [_vm._v("Documents Uploaded")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          _vm.getb2bTicketHistory(ticket)
        }
      }
    }, [_vm._v("View")])])]) : _vm._e()
  }), _vm._v(" "), (_vm.shipmentTickets.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "11",
      "align": "center"
    }
  }, [_vm._v("Tickets not found")])]) : _vm._e()], 2)]), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoadingPagination,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingPagination = $event
      }
    }
  })], 1), _vm._v(" "), (_vm.pagecount > 1) ? _c('paginate', {
    ref: "paginate",
    staticStyle: {
      "margin-top": "11px"
    },
    attrs: {
      "page-count": _vm.pagecount,
      "margin-pages": 3,
      "click-handler": _vm.getPaginationData,
      "prev-text": '⏮',
      "next-text": '⏭',
      "container-class": 'pagination',
      "page-class": 'page-item',
      "pageLinkClass": 'page-link-item'
    }
  }) : _vm._e()], 1)])])], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "no-enforce-focus": true
    },
    model: {
      value: (_vm.TicketLogModal),
      callback: function($$v) {
        _vm.TicketLogModal = $$v
      },
      expression: "TicketLogModal"
    }
  }, [_c('loading', {
    attrs: {
      "active": _vm.isModelLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isModelLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.TicketLogModal),
      expression: "TicketLogModal"
    }],
    staticClass: "col-lg-12",
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('b-card', {
    staticStyle: {
      "background-color": "transparent",
      "border": "0px solid transparent"
    }
  }, [_c('h6', {
    staticClass: "modal-title",
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("Ticket log")]), _vm._v(" "), _c('h5', {
    staticClass: "ship_id_head"
  }, [_vm._v("Ticket Id : "), _c('span', {
    staticClass: "modal_ship_id"
  }, [_vm._v(_vm._s(_vm.ticketIDLog))])]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeBModalCommonFunction('TicketLogModal')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row rowFullTable"
  }, [_c('div', {
    staticClass: "col-sm-12 col-xs-12 col-md-6 col-lg-12"
  }, [_c('table', {
    staticClass: "table table-responsive table-bordered"
  }, [_c('thead', {
    staticClass: "table-head"
  }, [_c('th', [_vm._v("Last updated on")]), _vm._v(" "), _c('th', [_vm._v("Resolution")]), _vm._v(" "), _c('th', [_vm._v("Ticket Status")]), _vm._v(" "), _c('th', [_vm._v("Comments")])]), _vm._v(" "), _c('tbody', {
    staticClass: "scrollDivCls"
  }, [_vm._l((_vm.resultTicket), function(ticket, index) {
    return (_vm.resultTicket.length > 0) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm._f("formatDatesingle")(ticket.createddate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ticket.action))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ticket.ticketstatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ticket.comments))])]) : _vm._e()
  }), _vm._v(" "), (_vm.resultTicket.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "10",
      "align": "center"
    }
  }, [_vm._v("Ticket Logs not found")])]) : _vm._e()], 2)])])])])])], 1)], 1), _vm._v(" "), _c('b-modal', {
    staticStyle: {
      "border-radius": "5px"
    },
    attrs: {
      "size": "vlg",
      "no-enforce-focus": true
    },
    model: {
      value: (_vm.ticketResultModal),
      callback: function($$v) {
        _vm.ticketResultModal = $$v
      },
      expression: "ticketResultModal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ticketResultModal),
      expression: "ticketResultModal"
    }],
    staticClass: "col-lg-12",
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('b-card', {
    staticStyle: {
      "background-color": "transparent",
      "border": "0px solid transparent",
      "margin-bottom": "0"
    }
  }, [_c('h5', {
    staticClass: "modal-title",
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Result")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeBModalCommonFunction('ticketResultModal')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "card-body modal-content",
    staticStyle: {
      "padding-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.ticketResultMsg)
    }
  }, [_vm._v(_vm._s(_vm.ticketResultMsg) + "\n                ")]), _vm._v(" "), (_vm.ticket.length > 0 && _vm.ticket.action != 'RTO' && this.DepartmentID != '1') ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-top": "auto"
    },
    attrs: {
      "id": "show-ticket-modal"
    },
    on: {
      "click": function($event) {
        _vm.openTicketModal()
      }
    }
  }, [_vm._v("Update\n                  Ticket")]) : _vm._e(), _vm._v(" "), (_vm.ticket.ticketstatus == 'Open' && _vm.ticket.action == 'RTO') ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-top": "auto"
    },
    attrs: {
      "disabled": _vm.validated
    },
    on: {
      "click": function($event) {
        _vm.openUploadRTODocs(_vm.ticket)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v("Upload RTO Documents")]) : _vm._e(), _vm._v(" "), (_vm.ticket.ticketstatus == 'Closed' && _vm.ticket.action == 'RTO') ? _c('button', [_vm._v("Documents Uploaded")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeBModalCommonFunction('ticketResultModal')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  }), _vm._v("Close")])])])])])])], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    model: {
      value: (_vm.IVRCallRecording.IVRCallRecordingModal),
      callback: function($$v) {
        _vm.IVRCallRecording.IVRCallRecordingModal = $$v
      },
      expression: "IVRCallRecording.IVRCallRecordingModal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.IVRCallRecording.IVRCallRecordingModal),
      expression: "IVRCallRecording.IVRCallRecordingModal"
    }],
    staticClass: "col-lg-12",
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('b-card', {
    staticStyle: {
      "background-color": "transparent",
      "border": "0px solid transparent"
    }
  }, [_c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("IVR Call Recording")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeBModalCommonFunction('IVRCallRecording.IVRCallRecordingModal')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row rowFullTable"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "tableFixHead"
  }, [_c('table', {
    staticClass: "table table-responsive table-bordered tableFixHeadBottom"
  }, [_c('thead', [_c('th', [_vm._v(" Process")]), _vm._v(" "), _c('th', [_vm._v("Queue")]), _vm._v(" "), _c('th', [_vm._v("Call Date")]), _vm._v(" "), _c('th', [_vm._v("Call Duration")]), _vm._v(" "), _c('th', [_vm._v("Recording")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.IVRCallRecording.IVRCallRecordingArr), function(RowEle, index) {
    return (_vm.IVRCallRecording.IVRCallRecordingArr.length > 0) ? _c('tr', [_c('td', [_vm._v(_vm._s(RowEle.UserProcess))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(RowEle.queue))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(RowEle.calldate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(RowEle.duration))]), _vm._v(" "), _c('td', [_c('i', {
      staticClass: "fa fa-file-audio-o fa-warningT",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          _vm.getIVRCallRecordingUrl(("" + (RowEle.uniqueid)))
        }
      }
    })])]) : _vm._e()
  }))])])])])])])], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    model: {
      value: (_vm.IVRCallRecording.IVRCallRecordingUrlModal),
      callback: function($$v) {
        _vm.IVRCallRecording.IVRCallRecordingUrlModal = $$v
      },
      expression: "IVRCallRecording.IVRCallRecordingUrlModal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.IVRCallRecording.IVRCallRecordingUrlModal),
      expression: "IVRCallRecording.IVRCallRecordingUrlModal"
    }],
    staticClass: "col-lg-12",
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('b-card', {
    staticStyle: {
      "background-color": "transparent",
      "border": "0px solid transparent"
    }
  }, [_c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("IVR Call Recording")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeIVRCallRecordingUrlModal()
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row rowFullTableT"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "tableFixHead"
  }, [_c('center', [_c('vue-audio', {
    attrs: {
      "file": _vm.IVRCallRecording.AudioUrl
    }
  })], 1)], 1)])])])])], 1)]), _vm._v(" "), _c('b-modal', {
    staticStyle: {
      "border-radius": "5px"
    },
    attrs: {
      "size": "vlg",
      "no-enforce-focus": true
    },
    model: {
      value: (_vm.listExisitngTicketModal),
      callback: function($$v) {
        _vm.listExisitngTicketModal = $$v
      },
      expression: "listExisitngTicketModal"
    }
  }, [_c('loading', {
    attrs: {
      "active": _vm.isModelLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isModelLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "padding": "5px"
    },
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('b-card', {
    staticStyle: {
      "background-color": "transparent",
      "border": "0px solid transparent",
      "margin-bottom": "0"
    }
  }, [_c('h5', {
    staticClass: "modal-title",
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Update Ticket")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.resetUpdateTicketModal(), _vm.listExisitngTicketModal = false;
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "card-body modal-content",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 cardlistheader",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.updateExistingBulkTicket),
      expression: "updateExistingBulkTicket"
    }],
    staticClass: "btn btn-primary cst_btn",
    attrs: {
      "type": "button",
      "id": "show-modal"
    },
    on: {
      "click": function($event) {
        _vm.openUpdateTicketModal();
      }
    }
  }, [_vm._v("Update\n                Ticket")]), _vm._v(" "), (_vm.updateExistingBulkTicket == false) ? _c('button', {
    staticClass: "btn btn-primary cst_btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.updateExistingBulkTicket = true;
        _vm.showBulkTicketDiv = false;
      }
    }
  }, [_vm._v("Back")]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.updateExistingBulkTicket),
      expression: "updateExistingBulkTicket"
    }],
    staticClass: "col-md-12 col-lg-12",
    staticStyle: {
      "margin-left": "0px"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable tableFixHeadBottom"
  }, [_c('thead', {
    staticClass: "table-head"
  }, [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "bind-title": "Select All"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectAllRecord),
      expression: "selectAllRecord"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectAllRecord) ? _vm._i(_vm.selectAllRecord, null) > -1 : (_vm.selectAllRecord)
    },
    on: {
      "click": _vm.selectAllCheckbox,
      "__c": function($event) {
        var $$a = _vm.selectAllRecord,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectAllRecord = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.selectAllRecord = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectAllRecord = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Shipping ID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Ticket ID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Source")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Ticket Type")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Reason")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Sub reason")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Action")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Ticket Status")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Created Date")])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.ticket), function(data, index) {
    return (_vm.ticket.length > 0) ? _c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ticketIDS),
        expression: "ticketIDS"
      }],
      staticStyle: {
        "margin-left": "7px"
      },
      attrs: {
        "id": data.ticketid,
        "type": "checkbox"
      },
      domProps: {
        "value": data.ticketid,
        "checked": Array.isArray(_vm.ticketIDS) ? _vm._i(_vm.ticketIDS, data.ticketid) > -1 : (_vm.ticketIDS)
      },
      on: {
        "click": function($event) {
          _vm.selectTicket(data, index, $event)
        },
        "__c": function($event) {
          var $$a = _vm.ticketIDS,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data.ticketid,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.ticketIDS = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.ticketIDS = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.ticketIDS = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.shippingid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ticketid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.source))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.maintype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.subtype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.typename))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.action))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ticketstatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatDate")(data.createddate)))])]) : _vm._e()
  }), _vm._v(" "), (_vm.ticket.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "19",
      "align": "center"
    }
  }, [_vm._v("Data not found")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBulkTicketDiv),
      expression: "showBulkTicketDiv"
    }],
    staticClass: "col-lg-12",
    staticStyle: {
      "width": "1170px !important"
    },
    attrs: {
      "id": "bulkEditTicketDiv"
    }
  }, [_c('div', {
    staticClass: "row scrollDivShipmentGrid"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticClass: "col-md-4"
  }, [_vm._v("Source\n                    "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.source,
      "selected-option": _vm.selectedSourceObj,
      "placeholder": "Select Source"
    },
    on: {
      "select": _vm.selectedSource
    },
    model: {
      value: (_vm.sourceId),
      callback: function($$v) {
        _vm.sourceId = $$v
      },
      expression: "sourceId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticClass: "col-md-4"
  }, [_vm._v("Ticket Type "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('basic-select', {
    staticStyle: {
      "width": "49%"
    },
    attrs: {
      "options": _vm.ticketType,
      "selected-option": _vm.selectedTicketObj,
      "placeholder": "Select Ticket"
    },
    on: {
      "select": _vm.selectedTicket
    },
    model: {
      value: (_vm.ticketTypeId),
      callback: function($$v) {
        _vm.ticketTypeId = $$v
      },
      expression: "ticketTypeId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [((_vm.ticketShipmentData.length == 1) && (_vm.selectedSubReasonObj.text == 'Change RTO address' || _vm.selectedSubReasonObj.text == 'Change delivery address' || _vm.selectedSubReasonObj.text == 'Change delivery address as per Client' ||
      _vm.selectedSubReasonObj.text == 'Change DTO address' || _vm.selectedSubReasonObj.text == 'Change Pickup address' ||
      _vm.selectedSubReasonObj.text == 'Redirect to Bank') &&
    (_vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM || this.selectedActionObj.value == _vm.ADDRESS_UPDATED || _vm.selectedActionObj.value == _vm.ADDDESS_CHANGE_REQUESTED)) ? _c('div', [_c('label', {
    staticClass: "col-md-3"
  }, [_vm._v("Address : ")]), _vm._v(" "), _c('b-form-textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:3|max:200'),
      expression: "'required|min:3|max:200'"
    }],
    staticClass: "txtModalAddress",
    staticStyle: {
      "width": "60%",
      "float": "right",
      "margin-right": "30px"
    },
    attrs: {
      "name": "address",
      "placeholder": "Enter Address",
      "rows": "4",
      "max-rows": "6"
    },
    model: {
      value: (_vm.newAddress),
      callback: function($$v) {
        _vm.newAddress = $$v
      },
      expression: "newAddress"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('address')),
      expression: "errors.has('address')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('address')),
      expression: "errors.has('address')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('address')))])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticClass: "col-md-4"
  }, [_vm._v("Reason\n                    "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.reason,
      "selected-option": _vm.selectedReasonObj,
      "placeholder": "Select Reason"
    },
    on: {
      "select": _vm.selectedReason
    },
    model: {
      value: (_vm.reasonId),
      callback: function($$v) {
        _vm.reasonId = $$v
      },
      expression: "reasonId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [((_vm.ticketShipmentData.length == 1) && (_vm.selectedSubReasonObj.text == 'Change RTO address' || _vm.selectedSubReasonObj.text == 'Change delivery address' || _vm.selectedSubReasonObj.text == 'Change delivery address as per Client' ||
      _vm.selectedSubReasonObj.text == 'Change DTO address' || _vm.selectedSubReasonObj.text == 'Change Pickup address' ||
      _vm.selectedSubReasonObj.text == 'Change misroute pincode' || _vm.selectedSubReasonObj.text == 'Redirect to Bank') &&
    (_vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM || this.selectedActionObj.value == _vm.ADDRESS_UPDATED || _vm.selectedActionObj.value == _vm.ADDDESS_CHANGE_REQUESTED)) ? _c('div', [_c('label', {
    staticClass: "col-md-3"
  }, [_vm._v("PinCode : ")]), _vm._v(" "), _c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric|digits:6'),
      expression: "'required|numeric|digits:6'"
    }],
    staticClass: "txtModalPincode",
    class: {
      'input': true, 'is-danger': _vm.errors.has('pincode')
    },
    staticStyle: {
      "width": "60%",
      "float": "right",
      "margin-right": "30px"
    },
    attrs: {
      "name": "pincode",
      "placeholder": "Pincode"
    },
    model: {
      value: (_vm.newPincode),
      callback: function($$v) {
        _vm.newPincode = $$v
      },
      expression: "newPincode"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pincode')),
      expression: "errors.has('pincode')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pincode')),
      expression: "errors.has('pincode')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('pincode')))])], 1) : _vm._e(), _vm._v(" "), (((_vm.ticketShipmentData.length == 1 && (_vm.selectedReasonObj.text == 'Arrange delivery' ||
      (_vm.selectedReasonObj.text == 'Non Behavioral' && _vm.selectedSubReasonObj.text == 'Delay in service') ||
      (_vm.selectedReasonObj.text == 'SR related' && _vm.selectedSubReasonObj.text == 'Fake update') ||
      _vm.selectedSubReasonObj.value == _vm.FAKE_NDR || _vm.selectedSubReasonObj.value == _vm.REFUSED_DOORSTEP_DELIVERY ||
      _vm.selectedSubReasonObj.value == _vm.DELAY_IN_PICKUP_SUB_REASON || _vm.selectedSubReasonObj.value == _vm.FAKE_NPR ||
      _vm.selectedSubReasonObj.value == _vm.FAKE_PICKUP || _vm.selectedSubReasonObj.value == _vm.DENIED_PICKUP ||
      _vm.selectedSubReasonObj.value == _vm.CHANGE_REATTEMPT_DATE ||
      _vm.selectedReasonObj.text == 'Arrange pickup') && (_vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM || _vm.selectedActionObj.value == _vm.REATTEMPT_DATE_CHANGED || _vm.selectedActionObj.value == _vm.ATTEMPT_DELIVERY)) ||
    (_vm.ticketShipmentData.length > 1 && _vm.selectedActionObj.value == _vm.ARRANGED_ASSIGN_OPS_TEAM || _vm.selectedActionObj.value == _vm.REATTEMPT_DATE_CHANGED))) ? _c('div', [_c('label', {
    staticClass: "col-md-4"
  }, [_vm._v("Reattempt Date\n                      "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "format": _vm.format,
      "not-before": _vm.startDate,
      "not-after": _vm.endDate
    },
    model: {
      value: (_vm.newReAttemptDate),
      callback: function($$v) {
        _vm.newReAttemptDate = $$v
      },
      expression: "newReAttemptDate"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectedSubReasonObj.text == 'Change payment mode / amount') ? _c('div', [_c('label', {
    staticClass: "label_text"
  }, [_vm._v("Payment Method : ")]), _vm._v(" "), _c('basic-select', {
    staticStyle: {
      "width": "60.3%"
    },
    attrs: {
      "options": _vm.payMethods,
      "selected-option": _vm.selectedMethodObj,
      "placeholder": "Select Payment Method",
      "isDisabled": _vm.disPaymentMethod
    },
    on: {
      "select": _vm.selectedMethod
    },
    model: {
      value: (_vm.methodId),
      callback: function($$v) {
        _vm.methodId = $$v
      },
      expression: "methodId"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('methodId')),
      expression: "errors.has('methodId')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('methodId')),
      expression: "errors.has('methodId')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('methodId')))])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticClass: "col-md-4"
  }, [_vm._v("Sub\n                    Reason "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.subReason,
      "name": "subReasonId",
      "selected-option": _vm.selectedSubReasonObj,
      "placeholder": "Select Sub Reason"
    },
    on: {
      "select": _vm.selectedSubReason
    },
    model: {
      value: (_vm.subReasonId),
      callback: function($$v) {
        _vm.subReasonId = $$v
      },
      expression: "subReasonId"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('subReasonId')),
      expression: "errors.has('subReasonId')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('subReasonId')),
      expression: "errors.has('subReasonId')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('subReasonId')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [((_vm.ticketShipmentData.length == 1 && _vm.selectedSubReasonObj.value == _vm.UPDATE_ALTERNATE_CONTACT_NO &&
    (_vm.selectedActionObj.value == _vm.CONTACT_DETAILS_UPDATED || _vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM) ||
    ((_vm.selectedSubReasonObj.text == 'Change RTO address' || _vm.selectedSubReasonObj.text == 'Change delivery address' || _vm.selectedSubReasonObj.text == 'Change delivery address as per Client' ||
      _vm.selectedSubReasonObj.text == 'Change DTO address' || _vm.selectedSubReasonObj.text == 'Change Pickup address' ||
      _vm.selectedSubReasonObj.text == 'Redirect to Bank') && (_vm.newAlternateContactNo != null || _vm.newAlternateContactNo != undefined) && (_vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM || this.selectedActionObj.value == _vm.ADDRESS_UPDATED)))) ? _c('div', [_c('label', {
    staticClass: "col-md-3"
  }, [_vm._v("Contact No : ")]), _vm._v(" "), _c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|digits:10|min:10|max:10'),
      expression: "'required|digits:10|min:10|max:10'"
    }],
    staticStyle: {
      "width": "60%",
      "float": "right",
      "margin-right": "30px"
    },
    attrs: {
      "name": "newAlternateContactNo",
      "placeholder": ""
    },
    model: {
      value: (_vm.newAlternateContactNo),
      callback: function($$v) {
        _vm.newAlternateContactNo = $$v
      },
      expression: "newAlternateContactNo"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('newAlternateContactNo')),
      expression: "errors.has('newAlternateContactNo')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('newAlternateContactNo')),
      expression: "errors.has('newAlternateContactNo')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('newAlternateContactNo')))])], 1) : _vm._e(), _vm._v(" "), ((_vm.ticketShipmentData.length == 1 && _vm.selectedSubReasonObj.value == _vm.UPDATE_EMAIL_ADDRESS &&
    (_vm.selectedActionObj.value == _vm.CONTACT_DETAILS_UPDATED || _vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM))) ? _c('div', [_c('label', {
    staticClass: "col-md-3"
  }, [_vm._v("Email Address : ")]), _vm._v(" "), _c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "txtModalEmailAddress",
    attrs: {
      "name": "emailAddress",
      "placeholder": "Email Address"
    },
    model: {
      value: (_vm.newEmailAddress),
      callback: function($$v) {
        _vm.newEmailAddress = $$v
      },
      expression: "newEmailAddress"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('emailAddress')),
      expression: "errors.has('emailAddress')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('emailAddress')),
      expression: "errors.has('emailAddress')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('emailAddress')))])], 1) : _vm._e(), _vm._v(" "), ((_vm.ticketShipmentData.length == 1 && _vm.selectedSubReasonObj.text == 'Change payment mode / amount' && _vm.orderTypeId == 'CashOnDelivery' &&
    (_vm.selectedActionObj.value == _vm.STATUS_CHANGED || _vm.selectedActionObj.value == _vm.ASSIGNED_CS_TEAM || _vm.selectedActionObj.value == _vm.PAYMENT_DETAILS_CHANGE_REQUESTED))) ? _c('div', [_c('label', {
    staticClass: "col-md-3"
  }, [_vm._v("Net Payment : ")]), _vm._v(" "), _c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|decimal:2|between:1,10000000'),
      expression: "'required|decimal:2|between:1,10000000'"
    }],
    staticClass: "txtModalNetPayment",
    staticStyle: {
      "width": "59%",
      "float": "right",
      "margin-right": "28px"
    },
    attrs: {
      "name": "netPayment",
      "placeholder": "",
      "disabled": _vm.disPayment
    },
    model: {
      value: (_vm.netPayment),
      callback: function($$v) {
        _vm.netPayment = $$v
      },
      expression: "netPayment"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('netPayment')),
      expression: "errors.has('netPayment')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('netPayment')),
      expression: "errors.has('netPayment')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('netPayment')))])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticClass: "col-md-4"
  }, [_vm._v("\n                    Resolution / Action "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.action,
      "placeholder": "Select Action",
      "selected-option": _vm.selectedActionObj
    },
    on: {
      "select": _vm.updateSelectedAction
    },
    model: {
      value: (_vm.actionId),
      callback: function($$v) {
        _vm.actionId = $$v
      },
      expression: "actionId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6",
    staticStyle: {
      "width": "50%",
      "float": "left"
    }
  }, [_c('label', {
    staticClass: "col-md-4"
  }, [_vm._v("Ticket Status "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" :\n                  ")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.ticketStatus,
      "placeholder": "Select Status",
      "selected-option": _vm.selectedTicketStatusObj
    },
    on: {
      "select": _vm.selectedTicketStatus
    },
    model: {
      value: (_vm.ticketStatusId),
      callback: function($$v) {
        _vm.ticketStatusId = $$v
      },
      expression: "ticketStatusId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-8"
  }, [_c('label', {
    staticClass: "col-md-3"
  }, [_vm._v("Comments "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" : ")]), _vm._v(" "), _c('b-form-textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min:3|max:300'),
      expression: "'min:3|max:300'"
    }],
    staticClass: "model-form-textarea",
    attrs: {
      "name": "comments",
      "placeholder": "",
      "rows": "5"
    },
    model: {
      value: (_vm.comments),
      callback: function($$v) {
        _vm.comments = $$v
      },
      expression: "comments"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('comments')),
      expression: "errors.has('comments')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('comments')),
      expression: "errors.has('comments')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('comments')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form_btn",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "disabled": _vm.validated ? '' : _vm.ticket.disabled || _vm.errors.any()
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.saveBulkEditShipment($event)
      }
    }
  }, [_vm._v("Save")])])])])])])])])], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "md",
      "data-toggle": "modal"
    },
    model: {
      value: (_vm.modalshowProductType),
      callback: function($$v) {
        _vm.modalshowProductType = $$v
      },
      expression: "modalshowProductType"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Product Types\n          "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModalshowProductType
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('b-form-fieldset', [_c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "table table-bordered tableFixHead"
  }, [_c('thead', {
    staticClass: "thead-dark"
  }, [_c('tr', [_c('th', [_vm._v("Sr. No.")]), _vm._v(" "), _c('th', [_vm._v("Product Type")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.OrderDetails.ProductType), function(val, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.SKU))])])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "downloadBtn",
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-danger btnCancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeModalshowProductType
    }
  }, [_vm._v(" Cancel")])])], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "no-enforce-focus": true
    },
    model: {
      value: (_vm.UploadRTODocsmodal),
      callback: function($$v) {
        _vm.UploadRTODocsmodal = $$v
      },
      expression: "UploadRTODocsmodal"
    }
  }, [_c('loading', {
    attrs: {
      "active": _vm.isModelLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isModelLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.UploadRTODocsmodal),
      expression: "UploadRTODocsmodal"
    }],
    staticClass: "col-lg-12",
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('b-card', {
    staticStyle: {
      "background-color": "transparent",
      "border": "0px solid transparent"
    }
  }, [_c('h5', {
    staticClass: "modal-title",
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v("Upload RTO Documents\n          "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeBModalCommonFunction('UploadRTODocsmodal')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  })]), _vm._v(" "), _c('span', {
    staticClass: "modal_ship_ids"
  }, [_c('label', [_vm._v("Shipment  Id : ")]), _c('span', {
    staticClass: "modal_ship_ids"
  }, [_vm._v(_vm._s(_vm.ShippingID))]), _vm._v(" "), _c('label', [_vm._v(" / Ticket Id : ")]), _vm._v(" "), _c('span', {
    staticClass: "modal_ship_ids"
  }, [_vm._v(_vm._s(_vm.ticket.ticketid))])])]), _vm._v("  \n        "), _c('b-form-fieldset', {
    staticStyle: {
      "border": "1px solid",
      "padding": "25px"
    }
  }, [_c('form', {
    attrs: {
      "method": "POST",
      "enctype": "multipart/form-data"
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "row col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-4 row"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Sales Return Note Number "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salesReturnNoteNo),
      expression: "salesReturnNoteNo"
    }],
    ref: "salesReturnNoteNo",
    staticClass: "form-control",
    staticStyle: {
      "width": "260px !important"
    },
    attrs: {
      "size": "lg",
      "required": "",
      "type": "text",
      "placeholder": "Enter Sales Return Note Number",
      "name": "salesReturnNoteNo",
      "id": "salesReturnNoteNo"
    },
    domProps: {
      "value": (_vm.salesReturnNoteNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.salesReturnNoteNo = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.isShowError == true) ? _c('span', {
    staticClass: "clientnote"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" Note: Enter Invoice Number.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 row"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("Sales Return Note Value "), _c('span', {
    staticClass: "compRedCss"
  }, [_vm._v("*")]), _vm._v(" :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salesReturnNoteValue),
      expression: "salesReturnNoteValue"
    }],
    ref: "salesReturnNoteValue",
    staticClass: "form-control",
    staticStyle: {
      "width": "260px !important"
    },
    attrs: {
      "size": "lg",
      "required": "",
      "type": "Float",
      "placeholder": "Enter Sales Return Note Value",
      "name": "salesReturnNoteValue",
      "id": "salesReturnNoteValue"
    },
    domProps: {
      "value": (_vm.salesReturnNoteValue)
    },
    on: {
      "change": function($event) {
        _vm.salesReturnNoteValueFun(_vm.salesReturnNoteValue)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.salesReturnNoteValue = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 row"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "role": "group"
    }
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("E-Way Bill Number :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.EwaybillNo),
      expression: "EwaybillNo"
    }],
    ref: "EwaybillNo",
    staticClass: "form-control",
    staticStyle: {
      "width": "223px !important"
    },
    attrs: {
      "size": "lg",
      "type": "number",
      "placeholder": "Enter E-way Bill Number",
      "name": "EwaybillNo",
      "id": "EwaybillNo"
    },
    domProps: {
      "value": (_vm.EwaybillNo)
    },
    on: {
      "keypress": _vm.onlyNumber,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.EwaybillNo = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-top": "-62px",
      "margin-left": "224px"
    },
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.validateEwayBillNumberValid()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Validate")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-5",
    staticStyle: {
      "border": "1px solid",
      "padding": "26px",
      "margin-top": "34px"
    }
  }, [_c('div', {
    staticClass: " file-upload"
  }, [_c('label', {
    attrs: {
      "for": "uploadImage"
    }
  }, [_c('i', {
    staticClass: "fa fa-upload",
    attrs: {
      "title": "Upload Sales Return Note",
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v(" Upload Sales Return Note")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), (_vm.imagefilepath != '') ? _c('span', [_vm._v(" \n                          "), (_vm.fileExtension == 'jpg' || _vm.fileExtension == 'jpeg' || _vm.fileExtension == 'pdf') ? _c('i', {
    staticClass: "fa fa-file-image-o",
    attrs: {
      "aria-hidden": "true",
      "title": "Download Image and pdf"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.imagefilepath)
      }
    }
  }) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('input', {
    ref: "uploadSalesReturnNote",
    staticClass: "btn btn-primary",
    attrs: {
      "required": "",
      "id": "uploadSalesReturnNote",
      "name": "uploadSalesReturnNote",
      "type": "file"
    },
    on: {
      "change": _vm.handleFileUploadSalesReturnNote
    }
  })]), _vm._v(" "), (_vm.SalesReturnNoteRTODocDataLink != '') ? _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "-35px",
      "margin-right": "-12px"
    }
  }, [_c('b-badge', {
    staticStyle: {
      "font-size": "17px"
    },
    attrs: {
      "variant": "light"
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    staticStyle: {
      "color": "green"
    }
  })]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "light",
      "size": "md",
      "disabled": _vm.validateduploadSalesReturnNote
    },
    on: {
      "click": function($event) {
        _vm.deleteUploadClick(_vm.SalesReturnNoteRTODocDataKey, 'uploadSalesReturnNote')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }), _vm._v(" "), (_vm.isShow === true) ? _c('div', {
    staticClass: "col-sm-5",
    staticStyle: {
      "border": "1px solid",
      "padding": "26px",
      "margin-top": "34px"
    }
  }, [_c('div', {
    staticClass: "file-upload"
  }, [_c('label', {
    attrs: {
      "for": "uploadImage"
    }
  }, [_c('i', {
    staticClass: "fa fa-upload",
    attrs: {
      "title": "Upload Eway Bill Number",
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v(" Upload E-way Bill Number : ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), (_vm.imagefilepath != '') ? _c('span', [_vm._v(" \n                        "), (_vm.fileExtension == 'jpg' || _vm.fileExtension == 'jpeg' || _vm.fileExtension == 'pdf') ? _c('i', {
    staticClass: "fa fa-file-image-o",
    attrs: {
      "aria-hidden": "true",
      "title": "Download eway Bill Number"
    },
    on: {
      "click": function($event) {
        _vm.fileview(_vm.imagefilepath)
      }
    }
  }) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('input', {
    ref: "uploadEbn",
    staticClass: "btn btn-primary",
    attrs: {
      "required": "",
      "id": "uploadEbn",
      "name": "uploadEbn",
      "type": "file"
    },
    on: {
      "change": _vm.handleFileUploadEBN
    }
  })]), _vm._v(" "), (_vm.ebnRTODocDataLink != '') ? _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "-35px",
      "margin-right": "-12px"
    }
  }, [_c('b-badge', {
    staticStyle: {
      "font-size": "17px"
    },
    attrs: {
      "variant": "light"
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    staticStyle: {
      "color": "green"
    }
  })]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "light",
      "size": "md",
      "disabled": _vm.validateduploadEbn
    },
    on: {
      "click": function($event) {
        _vm.deleteUploadClick(_vm.ebnRTODocDataKey, 'uploadEbn')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row col-md-12"
  }, [_c('div', {
    staticClass: "clientnote"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" Note: Allowed File Format JPG,JPEG,PDF."), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" Note: File Size Allowed Up to 5MB.\n              ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "75%",
      "margin-top": "-33px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "variant": "success",
      "name": "searchButton",
      "size": "sm"
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")]), _vm._v("  \n                "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.resetRTOuploadDoc
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")])])])])])], 1)], 1), _vm._v(" "), _c('b-card', {
    staticStyle: {
      "background-color": "transparent",
      "border": "0px solid transparent"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.UploadRTODocsmodal),
      expression: "UploadRTODocsmodal"
    }],
    staticClass: "row rowFullTable"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.UploadRTODocsmodal),
      expression: "UploadRTODocsmodal"
    }],
    staticClass: "col-sm-12 col-xs-12 col-md-6 col-lg-12"
  }, [_c('label', [_vm._v("Sum of Uploaded Invoices Value : ")]), _vm._v(_vm._s(_vm.resultTotalSum) + "\n            "), _c('br'), _vm._v(" "), _c('label', [_vm._v("Total Invoices Value : ")]), _vm._v(_vm._s(_vm.OrderDetails.TotalInvoiceValue) + "\n\n            "), _c('table', {
    staticClass: "table table-responsive table-bordered"
  }, [_c('thead', {
    staticClass: "table-head"
  }, [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Parent AWB")]), _vm._v(" "), _c('th', [_vm._v("Ticket ID")]), _vm._v(" "), _c('th', [_vm._v("Sales Return URL")]), _vm._v(" "), _c('th', [_vm._v("E-Way Bill URL")]), _vm._v(" "), _c('th', [_vm._v("Invoice No")]), _vm._v(" "), _c('th', [_vm._v("Declared Value")]), _vm._v(" "), _c('th', [_vm._v("E-Way Bill No")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Action")])]), _vm._v(" "), _c('tbody', {
    staticClass: "scrollDivCls"
  }, _vm._l((_vm.RTOresultTicket), function(ticketRTOdoc, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.ShippingID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ticketRTOdoc.ticketid))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-link",
      on: {
        "click": function($event) {
          _vm.getsalesReturnlink(ticketRTOdoc)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Sales Return URL")]), _vm._v(" \n                  "), _c('button', {
      staticClass: "btn btn-link",
      on: {
        "click": function($event) {
          _vm.viewSalesLink(ticketRTOdoc)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye",
      attrs: {
        "aria-hidden": "true"
      }
    })])]), _vm._v(" "), (ticketRTOdoc.ebns3url != 'NA') ? _c('td', [_c('button', {
      staticClass: "btn btn-link",
      on: {
        "click": function($event) {
          _vm.getlink(ticketRTOdoc)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Ebn URL")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-link",
      on: {
        "click": function($event) {
          _vm.viewEBNLink(ticketRTOdoc)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _c('td', [_vm._v("NA")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ticketRTOdoc.invoicenumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ticketRTOdoc.declaredvalue))]), _vm._v(" "), (ticketRTOdoc.ebnnumber) ? _c('td', [_vm._v(_vm._s(ticketRTOdoc.ebnnumber))]) : _c('td', [_vm._v(_vm._s(_vm.NAStr))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatDatesingle")(ticketRTOdoc.createddate)))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-outline-danger",
      attrs: {
        "size": "sm",
        "disabled": _vm.validated
      },
      on: {
        "click": function($event) {
          _vm.deleteRowActionClick(ticketRTOdoc)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-remove",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }))]), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoadingPagination,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingPagination = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.saveandclose(_vm.ticket, _vm.index)
      }
    },
    model: {
      value: (_vm.saveandcloseModal),
      callback: function($$v) {
        _vm.saveandcloseModal = $$v
      },
      expression: "saveandcloseModal"
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save & Close")])])], 1)])])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "data-toggle": "modal",
      "data-backdrop": "static",
      "data-keyboard": "false",
      "no-close-on-backdrop": true
    },
    model: {
      value: (_vm.previewImageModel),
      callback: function($$v) {
        _vm.previewImageModel = $$v
      },
      expression: "previewImageModel"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('h5', {
    staticClass: "modal-title",
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v(" " + _vm._s(_vm.titleNameLink) + " Image Preview\n            "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModelPreviewImage
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  })])])]), _vm._v(" "), _c('b-form-fieldset', [_c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "table table-bordered tableFixHead"
  }, [_c('thead', {
    staticClass: "thead-dark"
  }, [_c('tr', [_c('th', [_vm._v("Parent AWB")]), _vm._v(" "), _c('th', [_vm._v("Ticket ID")]), _vm._v(" "), _c('th', [_vm._v("Sales Return Note No.")]), _vm._v(" "), _c('th', [_vm._v("Sales Return Note Value")]), _vm._v(" "), _c('th', [_vm._v("Eway Bill No.")]), _vm._v(" "), _c('th', [_vm._v("Sales Return URL")]), _vm._v(" "), _c('th', [_vm._v("Eway Bill URL")])])]), _vm._v(" "), _c('tbody', [_c('td', [_vm._v(_vm._s(_vm.previewImageData.parentawb))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.previewImageData.ticketid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.previewImageData.invoicenumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.previewImageData.declaredvalue))]), _vm._v(" "), (_vm.previewImageData.ebnnumber) ? _c('td', [_vm._v(_vm._s(_vm.previewImageData.ebnnumber))]) : _c('td', [_vm._v(_vm._s(_vm.NAStr))]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-link",
    on: {
      "click": function($event) {
        _vm.getsalesReturnlink(_vm.previewImageData)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), (_vm.previewImageData.ebns3url != 'NA') ? _c('td', [_c('button', {
    staticClass: "btn btn-link",
    on: {
      "click": function($event) {
        _vm.getlink(_vm.previewImageData)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _c('td', [_vm._v("NA")])])])]), _vm._v(" "), (_vm.displayImageInBox === null) ? _c('b-alert', {
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v("\n                  POD image is not available\n              ")]) : _c('div', [(_vm.finalS3urlExt == 'pdf') ? _c('iframe', {
    staticStyle: {
      "width": "1125px",
      "height": "500px"
    },
    attrs: {
      "src": _vm.displayImageInBox,
      "frameborder": "0"
    }
  }) : _c('img', {
    staticClass: "wrapper",
    attrs: {
      "src": _vm.displayImageInBox,
      "width": "100%"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "downloadBtn",
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-danger btnCancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeModelPreviewImage
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle-o"
  }), _vm._v(" Cancel")])])], 1)], 1)], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h6', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("MPS Summary")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f9dde138","hasScoped":true}!./src/views/components/b2b/trackshipment/trackshipment.component.html
// module id = 932
// module chunks = 1